var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _rect, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _circle, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _rect2, _path273, _rect3, _rect4, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _rect5, _path281, _ellipse, _path282, _path283, _ellipse2, _path284, _path285, _ellipse3, _ellipse4, _path286, _path287, _path288, _path289, _path290, _path291;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileVg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2250.59 1373.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-3{fill:#bdd0fb;}.cls-4{opacity:0.9;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{opacity:0.88;}.cls-8{fill:#7d97f4;}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#linear-gradient-7);}.cls-13{fill:url(#linear-gradient-8);}.cls-14{fill:url(#linear-gradient-9);}.cls-15{fill:url(#linear-gradient-10);}.cls-16{fill:url(#linear-gradient-11);}.cls-17{fill:url(#linear-gradient-12);}.cls-18{fill:url(#linear-gradient-13);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#linear-gradient-19);}.cls-25{fill:url(#linear-gradient-20);}.cls-26{fill:url(#linear-gradient-21);}.cls-27{fill:url(#linear-gradient-22);}.cls-28{fill:url(#linear-gradient-23);}.cls-29{fill:url(#linear-gradient-24);}.cls-30{fill:url(#linear-gradient-25);}.cls-31{fill:url(#linear-gradient-26);}.cls-32{fill:url(#linear-gradient-27);}.cls-33{fill:url(#linear-gradient-28);}.cls-34{fill:url(#linear-gradient-29);}.cls-35{fill:url(#linear-gradient-30);}.cls-36{fill:url(#linear-gradient-31);}.cls-37{fill:url(#linear-gradient-32);}.cls-38{fill:url(#linear-gradient-33);}.cls-39{fill:url(#linear-gradient-34);}.cls-40{fill:url(#linear-gradient-35);}.cls-41{fill:url(#linear-gradient-36);}.cls-42{fill:url(#linear-gradient-37);}.cls-43{fill:url(#linear-gradient-38);}.cls-44{fill:url(#linear-gradient-39);}.cls-45{fill:url(#linear-gradient-40);}.cls-46{fill:url(#linear-gradient-41);}.cls-47{fill:url(#linear-gradient-42);}.cls-48{fill:url(#linear-gradient-43);}.cls-49{fill:url(#linear-gradient-44);}.cls-50{fill:url(#linear-gradient-45);}.cls-51{fill:url(#linear-gradient-46);}.cls-52{fill:url(#linear-gradient-47);}.cls-53{fill:url(#linear-gradient-48);}.cls-54{fill:url(#linear-gradient-49);}.cls-55{fill:url(#linear-gradient-50);}.cls-56{fill:url(#linear-gradient-51);}.cls-57{fill:url(#linear-gradient-52);}.cls-58{fill:url(#linear-gradient-53);}.cls-59{fill:url(#linear-gradient-54);}.cls-60{fill:url(#linear-gradient-55);}.cls-61{fill:url(#linear-gradient-56);}.cls-62{fill:url(#linear-gradient-57);}.cls-63{fill:url(#linear-gradient-58);}.cls-64{fill:url(#linear-gradient-59);}.cls-65{fill:url(#linear-gradient-60);}.cls-66{fill:url(#linear-gradient-61);}.cls-67{fill:url(#linear-gradient-62);}.cls-68{fill:url(#linear-gradient-63);}.cls-69{fill:url(#linear-gradient-64);}.cls-70{fill:url(#linear-gradient-65);}.cls-71{fill:url(#linear-gradient-66);}.cls-72{fill:url(#linear-gradient-67);}.cls-73{fill:url(#linear-gradient-68);}.cls-74{fill:url(#linear-gradient-69);}.cls-75{fill:url(#linear-gradient-70);}.cls-76{fill:url(#linear-gradient-71);}.cls-77{fill:url(#linear-gradient-72);}.cls-78{fill:url(#linear-gradient-73);}.cls-79{fill:url(#linear-gradient-74);}.cls-80{fill:url(#linear-gradient-75);}.cls-81{fill:url(#linear-gradient-76);}.cls-82{fill:url(#linear-gradient-77);}.cls-83{fill:url(#linear-gradient-78);}.cls-84{fill:url(#linear-gradient-79);}.cls-85{fill:url(#linear-gradient-80);}.cls-86{fill:url(#linear-gradient-81);}.cls-87{fill:url(#linear-gradient-82);}.cls-88{fill:url(#linear-gradient-83);}.cls-89{fill:url(#linear-gradient-84);}.cls-90{fill:url(#linear-gradient-85);}.cls-91{fill:url(#linear-gradient-86);}.cls-92{fill:url(#linear-gradient-87);}.cls-93{fill:url(#linear-gradient-88);}.cls-94{fill:url(#linear-gradient-89);}.cls-95{fill:url(#linear-gradient-90);}.cls-96{fill:url(#linear-gradient-91);}.cls-97{fill:url(#linear-gradient-92);}.cls-98{fill:url(#linear-gradient-93);}.cls-99{fill:url(#linear-gradient-94);}.cls-100{fill:url(#linear-gradient-95);}.cls-101{fill:url(#linear-gradient-96);}.cls-102{fill:url(#linear-gradient-97);}.cls-103{fill:url(#linear-gradient-98);}.cls-104{fill:url(#linear-gradient-99);}.cls-105{fill:url(#linear-gradient-100);}.cls-106{fill:url(#linear-gradient-101);}.cls-107{fill:url(#linear-gradient-102);}.cls-108{fill:url(#linear-gradient-103);}.cls-109{fill:url(#linear-gradient-104);}.cls-110{fill:url(#linear-gradient-105);}.cls-111{fill:url(#linear-gradient-106);}.cls-112{fill:url(#linear-gradient-107);}.cls-113{fill:url(#linear-gradient-108);}.cls-114{fill:url(#linear-gradient-109);}.cls-115{fill:url(#linear-gradient-110);}.cls-116{fill:url(#linear-gradient-111);}.cls-117{fill:url(#linear-gradient-112);}.cls-118{fill:url(#linear-gradient-113);}.cls-119{fill:url(#linear-gradient-114);}.cls-120{fill:url(#linear-gradient-115);}.cls-121{fill:url(#linear-gradient-116);}.cls-122{fill:url(#linear-gradient-117);}.cls-123{fill:url(#linear-gradient-118);}.cls-124{fill:url(#linear-gradient-119);}.cls-125{fill:url(#linear-gradient-120);}.cls-126{fill:url(#linear-gradient-121);}.cls-127{fill:url(#linear-gradient-122);}.cls-128{fill:url(#linear-gradient-123);}.cls-129{fill:url(#linear-gradient-124);}.cls-130{fill:url(#linear-gradient-125);}.cls-131{fill:url(#linear-gradient-126);}.cls-132{fill:url(#linear-gradient-127);}.cls-133{fill:url(#linear-gradient-128);}.cls-134{fill:url(#linear-gradient-129);}.cls-135{fill:url(#linear-gradient-130);}.cls-136{fill:url(#linear-gradient-131);}.cls-137{fill:url(#linear-gradient-132);}.cls-138{fill:url(#linear-gradient-133);}.cls-139{fill:url(#linear-gradient-134);}.cls-140{fill:url(#linear-gradient-135);}.cls-141{fill:url(#linear-gradient-136);}.cls-142{fill:url(#linear-gradient-137);}.cls-143{fill:url(#linear-gradient-138);}.cls-144{fill:url(#linear-gradient-139);}.cls-145{fill:url(#linear-gradient-140);}.cls-146{fill:url(#linear-gradient-141);}.cls-147{fill:url(#linear-gradient-142);}.cls-148{fill:url(#linear-gradient-143);}.cls-149{fill:url(#linear-gradient-144);}.cls-150{fill:url(#linear-gradient-145);}.cls-151{fill:url(#linear-gradient-146);}.cls-152{fill:url(#linear-gradient-147);}.cls-153{fill:url(#linear-gradient-148);}.cls-154{fill:url(#linear-gradient-149);}.cls-155{fill:url(#linear-gradient-150);}.cls-156{fill:url(#linear-gradient-151);}.cls-157{fill:url(#linear-gradient-152);}.cls-158{fill:url(#linear-gradient-153);}.cls-159{fill:url(#linear-gradient-154);}.cls-160{fill:url(#linear-gradient-155);}.cls-161{fill:url(#linear-gradient-156);}.cls-162{fill:url(#linear-gradient-157);}.cls-163{fill:url(#linear-gradient-158);}.cls-164{fill:url(#linear-gradient-159);}.cls-165{fill:url(#linear-gradient-160);}.cls-166{fill:url(#linear-gradient-161);}.cls-167{fill:url(#linear-gradient-162);}.cls-168{fill:url(#linear-gradient-163);}.cls-169{fill:url(#linear-gradient-164);}.cls-170{fill:url(#linear-gradient-165);}.cls-171{fill:url(#linear-gradient-166);}.cls-172{fill:url(#linear-gradient-167);}.cls-173{fill:url(#linear-gradient-168);}.cls-174{fill:url(#linear-gradient-169);}.cls-175{fill:url(#linear-gradient-170);}.cls-176{fill:url(#linear-gradient-171);}.cls-177{fill:url(#linear-gradient-172);}.cls-178{fill:url(#linear-gradient-173);}.cls-179{fill:url(#linear-gradient-174);}.cls-180{fill:url(#linear-gradient-175);}.cls-181{fill:url(#linear-gradient-176);}.cls-182{fill:url(#linear-gradient-177);}.cls-183{fill:url(#linear-gradient-178);}.cls-184{fill:url(#linear-gradient-179);}.cls-185{fill:url(#linear-gradient-180);}.cls-186{fill:url(#linear-gradient-181);}.cls-187{fill:url(#linear-gradient-182);}.cls-188{fill:url(#linear-gradient-183);}.cls-189{fill:url(#linear-gradient-184);}.cls-190{fill:url(#linear-gradient-185);}.cls-191{fill:url(#linear-gradient-186);}.cls-192{fill:url(#linear-gradient-187);}.cls-193{fill:url(#linear-gradient-188);}.cls-194{fill:url(#linear-gradient-189);}.cls-195{fill:url(#linear-gradient-190);}.cls-196{fill:url(#linear-gradient-191);}.cls-197{fill:url(#linear-gradient-192);}.cls-198{fill:url(#linear-gradient-193);}.cls-199{fill:url(#linear-gradient-194);}.cls-200{fill:url(#linear-gradient-195);}.cls-201{fill:url(#linear-gradient-196);}.cls-202{fill:url(#linear-gradient-197);}.cls-203{fill:url(#linear-gradient-198);}.cls-204{fill:url(#linear-gradient-199);}.cls-205{fill:url(#linear-gradient-200);}.cls-206{fill:url(#linear-gradient-201);}.cls-207{fill:url(#linear-gradient-202);}.cls-208{fill:url(#linear-gradient-203);}.cls-209{fill:url(#linear-gradient-204);}.cls-210{fill:url(#linear-gradient-205);}.cls-211{fill:url(#linear-gradient-206);}.cls-212{fill:url(#linear-gradient-207);}.cls-213{fill:url(#linear-gradient-208);}.cls-214{fill:url(#linear-gradient-209);}.cls-215{fill:url(#linear-gradient-210);}.cls-216{fill:url(#linear-gradient-211);}.cls-217{fill:url(#linear-gradient-212);}.cls-218{fill:url(#linear-gradient-213);}.cls-219{fill:url(#linear-gradient-214);}.cls-220{fill:url(#linear-gradient-215);}.cls-221{fill:url(#linear-gradient-216);}.cls-222{fill:url(#linear-gradient-217);}.cls-223{fill:url(#linear-gradient-218);}.cls-224{fill:url(#linear-gradient-219);}.cls-225{fill:url(#linear-gradient-220);}.cls-226{fill:url(#linear-gradient-221);}.cls-227{fill:url(#linear-gradient-222);}.cls-228{fill:url(#linear-gradient-223);}.cls-229,.cls-263{fill:#fff;}.cls-230{fill:url(#linear-gradient-224);}.cls-231{fill:url(#linear-gradient-225);}.cls-232{fill:url(#linear-gradient-226);}.cls-233{fill:url(#linear-gradient-227);}.cls-234{fill:url(#linear-gradient-228);}.cls-235{fill:url(#linear-gradient-229);}.cls-236{fill:url(#linear-gradient-230);}.cls-237{fill:url(#linear-gradient-231);}.cls-238{fill:#ff7414;}.cls-239{fill:url(#linear-gradient-232);}.cls-240{fill:url(#linear-gradient-233);}.cls-241{fill:url(#linear-gradient-234);}.cls-242{fill:url(#linear-gradient-235);}.cls-243{fill:url(#linear-gradient-236);}.cls-244{fill:url(#linear-gradient-237);}.cls-245{fill:url(#linear-gradient-238);}.cls-246{fill:url(#linear-gradient-239);}.cls-247{fill:url(#linear-gradient-240);}.cls-248{fill:url(#linear-gradient-241);}.cls-249{fill:url(#linear-gradient-242);}.cls-250{fill:url(#linear-gradient-243);}.cls-251{fill:url(#linear-gradient-244);}.cls-252{fill:url(#linear-gradient-245);}.cls-253{fill:url(#linear-gradient-246);}.cls-254{fill:url(#linear-gradient-247);}.cls-255{fill:url(#linear-gradient-248);}.cls-256{fill:url(#linear-gradient-249);}.cls-257{fill:url(#linear-gradient-250);}.cls-258{fill:url(#linear-gradient-251);}.cls-259{fill:url(#linear-gradient-252);}.cls-260{fill:url(#linear-gradient-253);}.cls-261{fill:url(#linear-gradient-254);}.cls-262{fill:url(#linear-gradient-255);}.cls-263{opacity:0.2;}.cls-264{fill:url(#linear-gradient-256);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 58.18,
    y1: 812.39,
    x2: 2029.63,
    y2: 812.39,
    gradientTransform: "matrix(1.11, -0.07, 0.07, 1.02, 7.07, -20.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 383.29,
    y1: 648.77,
    x2: 724.91,
    y2: 648.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2047.79,
    y1: 665.12,
    x2: 2339.34,
    y2: 665.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 131.91,
    y1: 996.91,
    x2: 389.21,
    y2: 996.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 266.73,
    y1: 1142.58,
    x2: 493.31,
    y2: 1142.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 207.79,
    y1: 1286.8,
    x2: 539.85,
    y2: 1286.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 214.78,
    y1: 1207.7,
    x2: 536.1,
    y2: 1207.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2429.98,
    y1: 126.9,
    x2: 801.97,
    y2: 1122.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 843.42,
    y1: 1321.75,
    x2: -356.71,
    y2: 2677.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1103.89,
    y1: 668.28,
    x2: 1130.89,
    y2: 1232.34,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1599.22,
    y1: 374.26,
    x2: 1462.4,
    y2: 561.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2208.73,
    y1: -447.58,
    x2: 1905.7,
    y2: -111.55,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2317.28,
    y1: -349.69,
    x2: 2014.25,
    y2: -13.65,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2015.02,
    y1: -622.26,
    x2: 1711.99,
    y2: -286.23,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2515.76,
    y1: -170.7,
    x2: 2212.73,
    y2: 165.33,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2495.52,
    y1: -188.96,
    x2: 2192.49,
    y2: 147.07,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2653.51,
    y1: -46.48,
    x2: 2350.48,
    y2: 289.55,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2800.07,
    y1: 85.68,
    x2: 2497.04,
    y2: 421.71,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1589.78,
    y1: 897.4,
    x2: 1592.66,
    y2: 897.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1584.27,
    y1: 904.48,
    x2: 1587.26,
    y2: 904.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1578.54,
    y1: 911.37,
    x2: 1581.63,
    y2: 911.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1572.59,
    y1: 918.07,
    x2: 1575.78,
    y2: 918.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1566.43,
    y1: 924.59,
    x2: 1569.72,
    y2: 924.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1560.07,
    y1: 930.91,
    x2: 1563.45,
    y2: 930.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1553.51,
    y1: 937.03,
    x2: 1556.99,
    y2: 937.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1546.77,
    y1: 942.94,
    x2: 1550.34,
    y2: 942.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1539.85,
    y1: 948.64,
    x2: 1543.51,
    y2: 948.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1532.75,
    y1: 954.13,
    x2: 1536.51,
    y2: 954.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1525.49,
    y1: 959.4,
    x2: 1529.33,
    y2: 959.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1518.07,
    y1: 964.44,
    x2: 1522,
    y2: 964.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1510.5,
    y1: 969.25,
    x2: 1514.51,
    y2: 969.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1502.79,
    y1: 973.83,
    x2: 1506.88,
    y2: 973.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1494.94,
    y1: 978.16,
    x2: 1499.1,
    y2: 978.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1486.96,
    y1: 982.26,
    x2: 1491.2,
    y2: 982.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1478.86,
    y1: 986.1,
    x2: 1483.17,
    y2: 986.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1470.64,
    y1: 989.68,
    x2: 1475.02,
    y2: 989.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1462.32,
    y1: 993.01,
    x2: 1466.77,
    y2: 993.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1453.89,
    y1: 996.07,
    x2: 1458.41,
    y2: 996.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1445.37,
    y1: 998.86,
    x2: 1449.96,
    y2: 998.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1436.77,
    y1: 1001.38,
    x2: 1441.42,
    y2: 1001.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1428.09,
    y1: 1003.61,
    x2: 1432.8,
    y2: 1003.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1419.35,
    y1: 1005.57,
    x2: 1424.11,
    y2: 1005.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1410.55,
    y1: 1007.24,
    x2: 1415.36,
    y2: 1007.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1401.7,
    y1: 1008.64,
    x2: 1406.57,
    y2: 1008.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1392.82,
    y1: 1009.76,
    x2: 1397.72,
    y2: 1009.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1383.92,
    y1: 1010.59,
    x2: 1388.84,
    y2: 1010.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1374.99,
    y1: 1011.15,
    x2: 1379.94,
    y2: 1011.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1366.05,
    y1: 1011.43,
    x2: 1371.02,
    y2: 1011.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1357.1,
    y1: 1011.44,
    x2: 1362.1,
    y2: 1011.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1348.16,
    y1: 1011.16,
    x2: 1353.18,
    y2: 1011.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1339.23,
    y1: 1010.62,
    x2: 1344.27,
    y2: 1010.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1330.33,
    y1: 1009.8,
    x2: 1335.38,
    y2: 1009.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1321.45,
    y1: 1008.7,
    x2: 1326.52,
    y2: 1008.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1312.62,
    y1: 1007.33,
    x2: 1317.7,
    y2: 1007.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1303.84,
    y1: 1005.68,
    x2: 1308.92,
    y2: 1005.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1295.11,
    y1: 1003.77,
    x2: 1300.19,
    y2: 1003.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1286.45,
    y1: 1001.58,
    x2: 1291.53,
    y2: 1001.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1277.86,
    y1: 999.12,
    x2: 1282.95,
    y2: 999.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1269.36,
    y1: 996.39,
    x2: 1274.44,
    y2: 996.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1260.95,
    y1: 993.38,
    x2: 1266.02,
    y2: 993.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1252.64,
    y1: 990.11,
    x2: 1257.71,
    y2: 990.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1244.44,
    y1: 986.57,
    x2: 1249.5,
    y2: 986.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1236.37,
    y1: 982.77,
    x2: 1241.41,
    y2: 982.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1228.42,
    y1: 978.7,
    x2: 1233.44,
    y2: 978.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1220.61,
    y1: 974.38,
    x2: 1225.61,
    y2: 974.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1212.94,
    y1: 969.8,
    x2: 1217.92,
    y2: 969.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1205.43,
    y1: 964.98,
    x2: 1210.39,
    y2: 964.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1198.09,
    y1: 959.91,
    x2: 1203.02,
    y2: 959.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1190.92,
    y1: 954.6,
    x2: 1195.81,
    y2: 954.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1183.93,
    y1: 949.05,
    x2: 1188.79,
    y2: 949.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1177.13,
    y1: 943.27,
    x2: 1181.96,
    y2: 943.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1170.54,
    y1: 937.26,
    x2: 1175.32,
    y2: 937.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1164.15,
    y1: 931.03,
    x2: 1168.9,
    y2: 931.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1158,
    y1: 924.58,
    x2: 1162.69,
    y2: 924.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1152.08,
    y1: 917.92,
    x2: 1156.72,
    y2: 917.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1146.4,
    y1: 911.05,
    x2: 1151,
    y2: 911.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1140.98,
    y1: 903.97,
    x2: 1145.52,
    y2: 903.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1135.83,
    y1: 896.7,
    x2: 1140.3,
    y2: 896.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1130.95,
    y1: 889.24,
    x2: 1135.36,
    y2: 889.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1126.36,
    y1: 881.59,
    x2: 1130.71,
    y2: 881.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1122.08,
    y1: 873.78,
    x2: 1126.36,
    y2: 873.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1118.1,
    y1: 865.8,
    x2: 1122.31,
    y2: 865.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1114.41,
    y1: 857.68,
    x2: 1118.55,
    y2: 857.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1111.04,
    y1: 849.43,
    x2: 1115.11,
    y2: 849.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1107.97,
    y1: 841.06,
    x2: 1111.97,
    y2: 841.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1105.2,
    y1: 832.58,
    x2: 1109.13,
    y2: 832.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1102.74,
    y1: 824.01,
    x2: 1106.6,
    y2: 824.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 1100.59,
    y1: 815.35,
    x2: 1104.38,
    y2: 815.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1098.75,
    y1: 806.62,
    x2: 1102.46,
    y2: 806.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1097.21,
    y1: 797.83,
    x2: 1100.86,
    y2: 797.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1095.99,
    y1: 788.99,
    x2: 1099.56,
    y2: 788.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1095.07,
    y1: 780.1,
    x2: 1098.57,
    y2: 780.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 1094.46,
    y1: 771.19,
    x2: 1097.9,
    y2: 771.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1094.17,
    y1: 762.26,
    x2: 1097.53,
    y2: 762.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1094.15,
    y1: 753.33,
    x2: 1097.52,
    y2: 753.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 1094.38,
    y1: 744.4,
    x2: 1097.87,
    y2: 744.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1094.93,
    y1: 735.48,
    x2: 1098.54,
    y2: 735.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1095.79,
    y1: 726.59,
    x2: 1099.52,
    y2: 726.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1096.97,
    y1: 717.75,
    x2: 1100.81,
    y2: 717.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1098.47,
    y1: 708.95,
    x2: 1102.43,
    y2: 708.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1100.28,
    y1: 700.22,
    x2: 1104.36,
    y2: 700.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1102.4,
    y1: 691.56,
    x2: 1106.6,
    y2: 691.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1104.85,
    y1: 682.98,
    x2: 1109.17,
    y2: 682.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1107.61,
    y1: 674.51,
    x2: 1112.05,
    y2: 674.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 1110.69,
    y1: 666.14,
    x2: 1115.24,
    y2: 666.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1114.07,
    y1: 657.9,
    x2: 1118.73,
    y2: 657.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1117.75,
    y1: 649.79,
    x2: 1122.52,
    y2: 649.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1121.71,
    y1: 641.81,
    x2: 1126.59,
    y2: 641.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 1125.96,
    y1: 633.98,
    x2: 1130.94,
    y2: 633.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1130.47,
    y1: 626.31,
    x2: 1135.56,
    y2: 626.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1135.25,
    y1: 618.8,
    x2: 1140.44,
    y2: 618.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 1140.29,
    y1: 611.46,
    x2: 1145.57,
    y2: 611.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 1145.57,
    y1: 604.3,
    x2: 1150.95,
    y2: 604.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 1151.09,
    y1: 597.32,
    x2: 1156.57,
    y2: 597.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1156.85,
    y1: 590.53,
    x2: 1162.41,
    y2: 590.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1162.83,
    y1: 583.94,
    x2: 1168.48,
    y2: 583.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1169.04,
    y1: 577.55,
    x2: 1174.76,
    y2: 577.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 1175.46,
    y1: 571.37,
    x2: 1181.25,
    y2: 571.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1182.08,
    y1: 565.41,
    x2: 1187.94,
    y2: 565.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1188.9,
    y1: 559.68,
    x2: 1194.83,
    y2: 559.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 1195.91,
    y1: 554.17,
    x2: 1201.9,
    y2: 554.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1203.09,
    y1: 548.91,
    x2: 1209.14,
    y2: 548.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 1210.46,
    y1: 543.89,
    x2: 1216.56,
    y2: 543.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1217.98,
    y1: 539.12,
    x2: 1224.15,
    y2: 539.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1225.67,
    y1: 534.61,
    x2: 1231.89,
    y2: 534.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 1233.51,
    y1: 530.38,
    x2: 1239.78,
    y2: 530.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 1241.49,
    y1: 526.41,
    x2: 1247.81,
    y2: 526.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1249.6,
    y1: 522.73,
    x2: 1255.97,
    y2: 522.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 1257.85,
    y1: 519.34,
    x2: 1264.26,
    y2: 519.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 1266.2,
    y1: 516.23,
    x2: 1272.65,
    y2: 516.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1274.66,
    y1: 513.42,
    x2: 1281.14,
    y2: 513.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 1283.21,
    y1: 510.91,
    x2: 1289.73,
    y2: 510.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 1291.85,
    y1: 508.68,
    x2: 1298.39,
    y2: 508.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 1300.55,
    y1: 506.74,
    x2: 1307.12,
    y2: 506.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 1309.31,
    y1: 505.09,
    x2: 1315.91,
    y2: 505.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1318.13,
    y1: 503.73,
    x2: 1324.74,
    y2: 503.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 1326.99,
    y1: 502.66,
    x2: 1333.62,
    y2: 502.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 1335.87,
    y1: 501.88,
    x2: 1342.52,
    y2: 501.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 1344.78,
    y1: 501.38,
    x2: 1351.44,
    y2: 501.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1353.7,
    y1: 501.17,
    x2: 1360.37,
    y2: 501.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 1362.63,
    y1: 501.24,
    x2: 1369.31,
    y2: 501.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 1371.56,
    y1: 501.59,
    x2: 1378.24,
    y2: 501.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 1380.47,
    y1: 502.23,
    x2: 1387.15,
    y2: 502.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 1389.35,
    y1: 503.15,
    x2: 1396.03,
    y2: 503.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 1398.21,
    y1: 504.35,
    x2: 1404.89,
    y2: 504.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 1407.03,
    y1: 505.83,
    x2: 1413.69,
    y2: 505.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 1415.79,
    y1: 507.58,
    x2: 1422.45,
    y2: 507.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 1424.5,
    y1: 509.62,
    x2: 1431.14,
    y2: 509.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 1433.13,
    y1: 511.94,
    x2: 1439.76,
    y2: 511.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 1441.69,
    y1: 514.53,
    x2: 1448.3,
    y2: 514.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 1450.16,
    y1: 517.4,
    x2: 1456.75,
    y2: 517.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 1458.53,
    y1: 520.54,
    x2: 1465.1,
    y2: 520.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 1466.8,
    y1: 523.96,
    x2: 1473.34,
    y2: 523.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 1474.95,
    y1: 527.65,
    x2: 1481.46,
    y2: 527.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 1482.99,
    y1: 531.58,
    x2: 1489.48,
    y2: 531.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 1490.93,
    y1: 535.71,
    x2: 1497.38,
    y2: 535.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 1498.77,
    y1: 540,
    x2: 1505.21,
    y2: 540,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 1506.53,
    y1: 544.43,
    x2: 1512.96,
    y2: 544.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 1514.24,
    y1: 548.96,
    x2: 1520.65,
    y2: 548.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 1521.9,
    y1: 553.56,
    x2: 1528.31,
    y2: 553.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 1529.54,
    y1: 558.19,
    x2: 1535.95,
    y2: 558.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 1537.17,
    y1: 562.82,
    x2: 1543.59,
    y2: 562.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 1544.81,
    y1: 567.43,
    x2: 1551.25,
    y2: 567.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 1552.49,
    y1: 571.98,
    x2: 1558.95,
    y2: 571.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 1560.22,
    y1: 576.44,
    x2: 1566.71,
    y2: 576.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 1568.01,
    y1: 580.78,
    x2: 1574.53,
    y2: 580.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 1575.89,
    y1: 584.96,
    x2: 1582.45,
    y2: 584.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 1583.86,
    y1: 588.95,
    x2: 1590.46,
    y2: 588.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 1591.95,
    y1: 592.7,
    x2: 1598.59,
    y2: 592.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 1600.15,
    y1: 596.18,
    x2: 1606.84,
    y2: 596.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 1608.47,
    y1: 599.36,
    x2: 1615.22,
    y2: 599.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 1616.93,
    y1: 602.18,
    x2: 1623.71,
    y2: 602.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 1625.5,
    y1: 604.62,
    x2: 1632.33,
    y2: 604.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 1634.18,
    y1: 606.62,
    x2: 1641.05,
    y2: 606.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 1642.96,
    y1: 608.18,
    x2: 1649.86,
    y2: 608.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 1651.81,
    y1: 609.27,
    x2: 1658.74,
    y2: 609.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 1660.72,
    y1: 609.86,
    x2: 1667.67,
    y2: 609.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 1669.64,
    y1: 609.93,
    x2: 1676.6,
    y2: 609.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 1678.56,
    y1: 609.45,
    x2: 1685.52,
    y2: 609.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 1687.44,
    y1: 608.4,
    x2: 1694.38,
    y2: 608.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 1696.22,
    y1: 606.75,
    x2: 1703.14,
    y2: 606.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 1704.88,
    y1: 604.48,
    x2: 1711.76,
    y2: 604.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 1713.35,
    y1: 601.56,
    x2: 1720.17,
    y2: 601.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 1721.57,
    y1: 597.98,
    x2: 1728.31,
    y2: 597.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 1729.49,
    y1: 593.75,
    x2: 1736.13,
    y2: 593.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 1737.04,
    y1: 588.9,
    x2: 1743.57,
    y2: 588.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 1744.18,
    y1: 583.45,
    x2: 1750.58,
    y2: 583.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 1750.85,
    y1: 577.43,
    x2: 1757.1,
    y2: 577.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 1756.98,
    y1: 570.86,
    x2: 1763.07,
    y2: 570.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 1762.51,
    y1: 563.76,
    x2: 1768.39,
    y2: 563.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 1767.34,
    y1: 556.18,
    x2: 1773.01,
    y2: 556.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 1771.4,
    y1: 548.17,
    x2: 1776.83,
    y2: 548.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 1774.62,
    y1: 539.79,
    x2: 1779.78,
    y2: 539.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 1776.89,
    y1: 531.12,
    x2: 1781.75,
    y2: 531.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 1778.17,
    y1: 522.26,
    x2: 1782.73,
    y2: 522.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 1778.37,
    y1: 513.33,
    x2: 1782.84,
    y2: 513.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 1777.42,
    y1: 504.44,
    x2: 1782.18,
    y2: 504.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 1775.51,
    y1: 495.69,
    x2: 1780.55,
    y2: 495.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 1772.63,
    y1: 487.19,
    x2: 1777.97,
    y2: 487.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 1768.8,
    y1: 479.06,
    x2: 1774.43,
    y2: 479.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 1764.01,
    y1: 471.43,
    x2: 1769.93,
    y2: 471.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 1758.29,
    y1: 464.47,
    x2: 1764.49,
    y2: 464.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 1751.68,
    y1: 458.32,
    x2: 1758.15,
    y2: 458.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 1744.27,
    y1: 453.18,
    x2: 1750.97,
    y2: 453.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 1736.2,
    y1: 449.19,
    x2: 1743.07,
    y2: 449.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 1727.68,
    y1: 446.36,
    x2: 1734.66,
    y2: 446.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 1718.88,
    y1: 444.7,
    x2: 1725.92,
    y2: 444.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 1709.96,
    y1: 444.21,
    x2: 1717.02,
    y2: 444.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 1701.08,
    y1: 444.91,
    x2: 1708.1,
    y2: 444.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 1692.4,
    y1: 446.82,
    x2: 1699.34,
    y2: 446.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 1684.13,
    y1: 449.97,
    x2: 1690.92,
    y2: 449.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 1676.49,
    y1: 454.39,
    x2: 1683.06,
    y2: 454.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 1669.74,
    y1: 460.04,
    x2: 1676,
    y2: 460.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 1664.17,
    y1: 466.83,
    x2: 1670.02,
    y2: 466.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 1660.01,
    y1: 474.6,
    x2: 1665.4,
    y2: 474.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 1657.3,
    y1: 483.02,
    x2: 1662.23,
    y2: 483.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 1656,
    y1: 491.81,
    x2: 1660.49,
    y2: 491.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 1655.91,
    y1: 500.73,
    x2: 1660.31,
    y2: 500.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 1656.93,
    y1: 509.57,
    x2: 1661.74,
    y2: 509.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 1659.31,
    y1: 518.11,
    x2: 1664.55,
    y2: 518.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 1663.08,
    y1: 526.09,
    x2: 1668.76,
    y2: 526.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 1668.25,
    y1: 533.2,
    x2: 1674.35,
    y2: 533.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 1674.75,
    y1: 539.09,
    x2: 1681.24,
    y2: 539.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 774.61,
    y1: 1065.56,
    x2: 1003.53,
    y2: 1065.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 755.57,
    y1: 985.64,
    x2: 816.48,
    y2: 985.64,
    gradientTransform: "translate(927.18 -267.12) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 537.6,
    y1: 600.78,
    x2: 541.58,
    y2: 600.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 537.96,
    y1: 488.83,
    x2: 835.51,
    y2: 488.83,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 849.92,
    y1: 458.01,
    x2: 858.39,
    y2: 458.01,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 906.22,
    y1: 591.4,
    x2: 909.85,
    y2: 591.4,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 604.69,
    y1: 695.31,
    x2: 907.44,
    y2: 695.31,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 583.1,
    y1: 712.39,
    x2: 591.3,
    y2: 712.39,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 1088.66,
    y1: 191.37,
    x2: 911.64,
    y2: 383.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 1088.78,
    y1: 191.48,
    x2: 911.76,
    y2: 383.5,
    xlinkHref: "#linear-gradient-232"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 957.74,
    y1: 433.02,
    x2: 879.74,
    y2: 745.05,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 1029.55,
    y1: 450.97,
    x2: 951.54,
    y2: 763,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 1079.02,
    y1: 463.33,
    x2: 1001.01,
    y2: 775.36,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 1036.13,
    y1: 452.61,
    x2: 958.12,
    y2: 764.64,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 967.21,
    y1: 435.38,
    x2: 889.21,
    y2: 747.41,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 922.17,
    y1: 424.12,
    x2: 844.16,
    y2: 736.15,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 964.38,
    y1: 246.33,
    x2: 946.38,
    y2: 510.36,
    xlinkHref: "#linear-gradient-232"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 964.62,
    y1: 246.35,
    x2: 946.62,
    y2: 510.38,
    xlinkHref: "#linear-gradient-232"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 1121.38,
    y1: 511.25,
    x2: 1124.41,
    y2: 511.25,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 920.02,
    y1: 589.45,
    x2: 1124.01,
    y2: 589.45,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 902.59,
    y1: 610.4,
    x2: 909.03,
    y2: 610.4,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 866.8,
    y1: 517.86,
    x2: 869.55,
    y2: 517.86,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 868.74,
    y1: 445.15,
    x2: 1076.27,
    y2: 445.15,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 1086.5,
    y1: 433.76,
    x2: 1092.76,
    y2: 433.76,
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 1298.23,
    y1: 181.37,
    x2: 1100.21,
    y2: 403.39,
    xlinkHref: "#linear-gradient-232"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 1298.14,
    y1: 181.28,
    x2: 1100.12,
    y2: 403.3,
    xlinkHref: "#linear-gradient-232"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 338.01,
    y1: 527.85,
    x2: 347.51,
    y2: 624.35,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 576.73,
    y1: 504.35,
    x2: 586.23,
    y2: 600.85,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 1906.4,
    y1: 399.46,
    x2: 1733.01,
    y2: 664.65,
    gradientTransform: "translate(269.42 -553.61) rotate(15.58)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 2072.51,
    y1: 292.05,
    x2: 2010.51,
    y2: 468.05,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 1762.28,
    y1: 483.5,
    x2: 1928.88,
    y2: 262.73,
    gradientTransform: "translate(950.56 -1160.27) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 2101.97,
    y1: 685.53,
    x2: 2043.31,
    y2: 814.19,
    gradientTransform: "translate(-242.34 -140.15) rotate(-4.57)",
    xlinkHref: "#linear-gradient-226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 1892.89,
    y1: 1155.74,
    x2: 1882.53,
    y2: 1204.58,
    xlinkHref: "#linear-gradient-8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.46,235.4C318.76,375.6,557,526.46,443.91,606.49s-591.81,253-82.16,500.78,543.38,382.08,882.58,182,303.8-180,600.28-79.1,586-105.15,469-319.67S2131.44,683,2239.35,534,2112.88-67.48,1729.4,261s-439,153-619.79,7C1011.74,189,736,13.82,480.46,235.4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M996.82,226.86a1,1,0,0,1-.82-.42c-.75-1.07-1.52-2.14-2.3-3.19a1,1,0,1,1,1.59-1.18c.79,1.06,1.57,2.14,2.34,3.23a1,1,0,0,1-.24,1.38A1,1,0,0,1,996.82,226.86Z",
    transform: "translate(-131.41 -117.6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M868.71,473.47c-1,0-1.92,0-2.89,0a1,1,0,0,1-1-1,1,1,0,0,1,1-1c.95,0,1.9.05,2.85,0,1.6,0,3.22,0,4.83-.08a1,1,0,0,1,.06,2C872,473.45,870.33,473.47,868.71,473.47Zm-15.4-.76h-.1c-2.56-.26-5.15-.58-7.71-1a1,1,0,0,1-.83-1.13,1,1,0,0,1,1.12-.83c2.53.37,5.09.69,7.62.94a1,1,0,0,1-.1,2Zm32.77-.22a1,1,0,0,1-.11-2c2.54-.29,5.09-.64,7.61-1a1,1,0,0,1,1.14.82,1,1,0,0,1-.82,1.14c-2.55.41-5.14.77-7.7,1.06ZM906,468.93a1,1,0,0,1-.23-2c2.15-.53,4.33-1.11,6.47-1.74l.94-.27a1,1,0,1,1,.56,1.9l-.95.28c-2.17.63-4.37,1.22-6.55,1.76A1,1,0,0,1,906,468.93Zm19.33-6.09a1,1,0,0,1-.35-1.92c2.37-.91,4.75-1.9,7.08-2.94a1,1,0,0,1,1.31.51,1,1,0,0,1-.5,1.3c-2.36,1-4.78,2.06-7.18,3A.92.92,0,0,1,925.36,462.84Zm18.39-8.51a1,1,0,0,1-.48-1.87c2.24-1.22,4.48-2.51,6.65-3.83a1,1,0,1,1,1,1.69c-2.19,1.34-4.46,2.65-6.73,3.89A1,1,0,0,1,943.75,454.33Zm17.12-10.83a1,1,0,0,1-.8-.41,1,1,0,0,1,.22-1.39c2.05-1.49,4.1-3.06,6.08-4.66a1,1,0,0,1,1.24,1.55c-2,1.62-4.07,3.2-6.16,4.72A1,1,0,0,1,960.87,443.5Zm15.56-13a1,1,0,0,1-.68-1.71c1.84-1.75,3.67-3.57,5.43-5.42a1,1,0,1,1,1.43,1.37c-1.78,1.87-3.63,3.72-5.5,5.49A1,1,0,0,1,976.43,430.54Zm13.76-14.87a1,1,0,0,1-.63-.22,1,1,0,0,1-.14-1.39c1.6-2,3.18-4,4.68-6.08a1,1,0,0,1,1.39-.21,1,1,0,0,1,.21,1.39c-1.52,2.08-3.12,4.14-4.74,6.15A1,1,0,0,1,990.19,415.67Zm11.72-16.52a1,1,0,0,1-.52-.14,1,1,0,0,1-.32-1.37c1.34-2.17,2.64-4.4,3.87-6.63a1,1,0,0,1,1.74,1c-1.25,2.26-2.57,4.52-3.92,6.71A1,1,0,0,1,1001.91,399.15Zm9.51-17.89a1,1,0,0,1-.4-.09,1,1,0,0,1-.5-1.31c1.05-2.32,2.05-4.7,3-7.07a1,1,0,0,1,1.28-.56,1,1,0,0,1,.56,1.29c-.94,2.4-2,4.81-3,7.16A1,1,0,0,1,1011.42,381.26Zm7.14-19a.92.92,0,0,1-.29,0,1,1,0,0,1-.66-1.24c.74-2.44,1.43-4.93,2-7.4a1,1,0,0,1,1.92.48c-.62,2.51-1.32,5-2.07,7.5A1,1,0,0,1,1018.56,362.29Zm4.62-19.73H1023a1,1,0,0,1-.82-1.15c.42-2.51.79-5.07,1.08-7.6a1,1,0,1,1,2,.23c-.3,2.56-.66,5.15-1.09,7.7A1,1,0,0,1,1023.18,342.56Zm2-20.17h0a1,1,0,0,1-1-1c.06-1.78.09-3.59.09-5.37,0-.77,0-1.54,0-2.31a1,1,0,1,1,2,0c0,.78,0,1.56,0,2.34,0,1.81,0,3.64-.09,5.44A1,1,0,0,1,1025.21,322.39Zm-.62-20.27a1,1,0,0,1-1-.9c-.24-2.53-.55-5.09-.92-7.62a1,1,0,1,1,2-.28c.38,2.56.69,5.15.94,7.71a1,1,0,0,1-.9,1.09Zm-3.24-20a1,1,0,0,1-1-.78c-.57-2.48-1.2-5-1.89-7.43a1,1,0,1,1,1.91-.54c.69,2.48,1.34,5,1.92,7.53a1,1,0,0,1-.75,1.19A.83.83,0,0,1,1021.35,282.12Zm-5.77-19.43a1,1,0,0,1-.93-.65c-.89-2.4-1.84-4.8-2.83-7.14a1,1,0,1,1,1.82-.77c1,2.37,2,4.8,2.87,7.22a1,1,0,0,1-.59,1.28A1,1,0,0,1,1015.58,262.69Zm-8.22-18.53a1,1,0,0,1-.88-.53c-1.18-2.26-2.43-4.52-3.72-6.71a1,1,0,1,1,1.71-1c1.3,2.22,2.57,4.5,3.77,6.79a1,1,0,0,1-.42,1.34A.92.92,0,0,1,1007.36,244.16Z",
    transform: "translate(-131.41 -117.6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M833.25,469.38a.9.9,0,0,1-.23,0q-1.95-.47-3.87-1a1,1,0,1,1,.5-1.92c1.27.33,2.54.65,3.82.95a1,1,0,0,1,.74,1.19A1,1,0,0,1,833.25,469.38Z",
    transform: "translate(-131.41 -117.6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M735.56,399.22a1,1,0,0,1-.84-.48c-.7-1.13-1.39-2.27-2.06-3.42a1,1,0,0,1,1.72-1c.66,1.14,1.34,2.27,2,3.38a1,1,0,0,1-.32,1.37A1,1,0,0,1,735.56,399.22Z",
    transform: "translate(-131.41 -117.6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M727.43,384.27a1,1,0,0,1-.9-.56c-1.15-2.42-2.25-4.91-3.28-7.39a1,1,0,0,1,1.84-.76c1,2.45,2.1,4.9,3.24,7.29a1,1,0,0,1-.47,1.33A1.11,1.11,0,0,1,727.43,384.27Zm-7.75-19.6a1,1,0,0,1-.94-.69c-.42-1.31-.83-2.64-1.22-4s-.71-2.52-1-3.78a1,1,0,0,1,.7-1.21,1,1,0,0,1,1.22.7c.33,1.25.67,2.49,1,3.74s.78,2.63,1.2,3.93a1,1,0,0,1-.64,1.25A1.1,1.1,0,0,1,719.68,364.67Zm-5.07-20.45a1,1,0,0,1-1-.82c-.47-2.65-.88-5.34-1.21-8a1,1,0,0,1,2-.24c.33,2.62.74,5.28,1.2,7.89a1,1,0,0,1-.8,1.15Zm-2.3-21a1,1,0,0,1-1-.95c-.09-2.15-.13-4.32-.13-6.47,0-.54,0-1.08,0-1.62a1,1,0,0,1,1-1,1,1,0,0,1,1,1c0,.53,0,1.06,0,1.6,0,2.12.05,4.27.13,6.38a1,1,0,0,1-.95,1Zm.56-21.08h-.09a1,1,0,0,1-.89-1.08c.25-2.68.58-5.38,1-8a1,1,0,0,1,2,.29c-.39,2.63-.71,5.29-1,7.94A1,1,0,0,1,712.87,302.19Zm3.41-20.8a.91.91,0,0,1-.23,0,1,1,0,0,1-.74-1.19c.61-2.61,1.3-5.25,2.05-7.82a1,1,0,1,1,1.9.55c-.73,2.54-1.41,5.14-2,7.72A1,1,0,0,1,716.28,281.39Zm6.17-20.15a1,1,0,0,1-.35-.07,1,1,0,0,1-.58-1.28c1-2.5,2-5,3.08-7.48a1,1,0,0,1,1.3-.51,1,1,0,0,1,.51,1.31c-1.07,2.43-2.09,4.92-3,7.39A1,1,0,0,1,722.45,261.24Zm8.81-19.15a1,1,0,0,1-.87-1.46c1.28-2.36,2.64-4.71,4-7a1,1,0,0,1,1.7,1c-1.39,2.26-2.73,4.59-4,6.91A1,1,0,0,1,731.26,242.09Zm11.29-17.79a1,1,0,0,1-.8-1.58c1.58-2.16,3.25-4.31,4.94-6.39a1,1,0,0,1,1.54,1.25c-1.68,2.06-3.32,4.18-4.88,6.31A1,1,0,0,1,742.55,224.3Zm13.57-16.12a1,1,0,0,1-.69-.28,1,1,0,0,1,0-1.4c1.86-1.93,3.8-3.84,5.75-5.67a1,1,0,0,1,1.36,1.45c-1.93,1.81-3.84,3.69-5.68,5.6A1,1,0,0,1,756.12,208.18ZM771.72,194a1,1,0,0,1-.78-.38,1,1,0,0,1,.17-1.39c2.1-1.67,4.27-3.29,6.46-4.84a1,1,0,1,1,1.14,1.61c-2.15,1.53-4.3,3.14-6.37,4.78A1,1,0,0,1,771.72,194Zm17.37-11.91a1,1,0,0,1-.85-.49,1,1,0,0,1,.35-1.36c2.31-1.36,4.68-2.68,7.06-3.92a1,1,0,0,1,1.34.42,1,1,0,0,1-.42,1.34c-2.35,1.22-4.7,2.53-7,3.87A1,1,0,0,1,789.09,182.13Zm18.83-9.45a1,1,0,0,1-.38-1.91c2.46-1,5-2,7.52-2.94a1,1,0,0,1,1.27.6,1,1,0,0,1-.59,1.27c-2.5.9-5,1.87-7.44,2.9A1,1,0,0,1,807.92,172.68Zm19.93-6.85a1,1,0,0,1-.26-2c2.6-.71,5.24-1.35,7.85-1.92a1,1,0,1,1,.42,1.94c-2.58.56-5.19,1.2-7.75,1.89A.82.82,0,0,1,827.85,165.83Zm70.64-2.62a.62.62,0,0,1-.19,0c-2.6-.5-5.25-.95-7.87-1.32a1,1,0,1,1,.27-2c2.66.37,5.34.82,8,1.34a1,1,0,0,1-.19,2Zm-50-1.53a1,1,0,0,1-.13-2c2.67-.35,5.37-.64,8-.85a1,1,0,0,1,1.07.91,1,1,0,0,1-.91,1.07c-2.64.21-5.31.49-7.94.83Zm29.07-1.08h-.06c-2.64-.15-5.33-.23-8-.25a1,1,0,1,1,0-2h0c2.69,0,5.4.1,8.08.25a1,1,0,0,1,0,2Z",
    transform: "translate(-131.41 -117.6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M915.06,167.38a.92.92,0,0,1-.29,0c-1.26-.39-2.52-.76-3.78-1.12a1,1,0,0,1,.54-1.91c1.28.36,2.56.74,3.82,1.14a1,1,0,0,1-.29,1.93Z",
    transform: "translate(-131.41 -117.6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M918.52,206.46a1.9,1.9,0,0,0-2.18.19l-17.41,14.82A99.6,99.6,0,0,0,867,216.93l-12.59-19.07a1.88,1.88,0,0,0-2-.78l-26.56,6.83a1.86,1.86,0,0,0-1.4,1.67l-1.84,22.77a100.05,100.05,0,0,0-25.79,19.4l-22.4-4.58a1.88,1.88,0,0,0-2,.89l-14,23.61a1.88,1.88,0,0,0,.18,2.17l14.82,17.41a99.64,99.64,0,0,0-4.54,31.95l-19.07,12.6a1.88,1.88,0,0,0-.78,2l6.83,26.56a1.89,1.89,0,0,0,1.67,1.41l22.78,1.83a99.46,99.46,0,0,0,19.39,25.79l-4.58,22.4a1.87,1.87,0,0,0,.89,2l23.61,14a1.9,1.9,0,0,0,2.18-.19l17.41-14.82a99.6,99.6,0,0,0,31.95,4.54l12.59,19.07a1.88,1.88,0,0,0,2,.78l26.56-6.83a1.88,1.88,0,0,0,1.4-1.67l1.83-22.77a99.71,99.71,0,0,0,25.79-19.4l22.41,4.58a1.88,1.88,0,0,0,2-.89l14-23.61a1.87,1.87,0,0,0-.19-2.17L964.71,347a99.37,99.37,0,0,0,4.55-32l19.06-12.6a1.87,1.87,0,0,0,.79-2l-6.84-26.56a1.89,1.89,0,0,0-1.66-1.41l-22.78-1.83a99.27,99.27,0,0,0-19.4-25.79l4.58-22.4a1.88,1.88,0,0,0-.88-2Z",
    transform: "translate(-131.41 -117.6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M869.1,343a26,26,0,0,1-7.33-1.07A25.62,25.62,0,1,1,869.1,343ZM869,294.24a22.93,22.93,0,1,0,6.49.94A23,23,0,0,0,869,294.24Z",
    transform: "translate(-131.41 -117.6)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M868.82,385.31a67.79,67.79,0,0,1-65.54-50.81,68.51,68.51,0,0,1-2.16-17A67.75,67.75,0,0,1,852,252.11a68.06,68.06,0,0,1,13-2l.29,0,.92,0,.12,3a65.13,65.13,0,0,0-13.63,2h0q-2.26.58-4.47,1.32a64.12,64.12,0,0,0-33,25l-.66,1c-.51.8-1,1.6-1.5,2.42a64.25,64.25,0,0,0-9,32.79,64.8,64.8,0,0,0,64.72,64.82,64.7,64.7,0,0,0,45.49-110.7l2.09-2.12a67.69,67.69,0,0,1-47.58,115.79Z",
    transform: "translate(-131.41 -117.6)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M780.11,1030.07S665.47,452.9,396,130.47c-18.11-21.68-53-14.86-61.45,12.1C278,322.81,162.22,871.55,780.11,1030.07Z",
    transform: "translate(-131.41 -117.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M724.45,991.09a1.55,1.55,0,0,1-2.1,2.28c-56.22-45.09-271.93-264.43-339-688.3a1.09,1.09,0,0,1,2.13-.46C409.91,403.19,511.45,767.09,724.45,991.09Z",
    transform: "translate(-131.41 -117.6)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M702.74,1080.78s-219-456.39-512.59-667.39c-19.73-14.19-47.34-1-48.61,23.23C133,598.9,154,1080.92,702.74,1080.78Z",
    transform: "translate(-131.41 -117.6)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M648,1060.21a1.34,1.34,0,0,1-1.27,2.35C590.26,1037,363.58,900.42,217,561.6a.94.94,0,0,1,1.67-.85C260.12,637.65,422.6,919.15,648,1060.21Z",
    transform: "translate(-131.41 -117.6)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2051.18,841.52s-18.35-214.16,100.4-280.1c113.92-63.25,145.72-7.25,198-91.24a4.8,4.8,0,0,1,8.85,1.89c6.27,48,16.88,210.76-120.63,243.17C2078.91,752.68,2051.18,841.52,2051.18,841.52Z",
    transform: "translate(-131.41 -117.6)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2337.27,519.14a73.59,73.59,0,0,1-5,12c-1.06,1.92-2,3.89-3.15,5.75l-3.43,5.59c-2.55,3.56-4.91,7.25-7.75,10.59-1.38,1.7-2.71,3.43-4.12,5.11l-4.43,4.85a218.08,218.08,0,0,1-40.29,33.53c-14.51,9.86-30.36,17.55-46.29,24.84l-12.2,4.94c-4,1.65-8.11,3.29-12.28,4.89l-6.21,2.44-6.14,2.62c-4.12,1.68-8.11,3.67-12.16,5.52-8,3.92-15.93,8-23.54,12.73-3.87,2.24-7.55,4.79-11.3,7.22-3.64,2.61-7.34,5.13-10.84,7.94a192.13,192.13,0,0,0-37.66,38.38,211.47,211.47,0,0,0-25.82,47.22C2058,771.92,2053,789.08,2048,806h0a4.65,4.65,0,0,0,8.91,2.64l0-.08c4.73-17,9.32-33.94,15.55-50.19a203.61,203.61,0,0,1,24.07-45.91,185,185,0,0,1,35.67-37.59c3.34-2.78,6.9-5.29,10.39-7.89,3.62-2.42,7.16-5,10.9-7.22,7.34-4.7,15-8.86,22.82-12.85,3.94-1.89,7.83-3.91,11.86-5.63l6-2.68,6.08-2.5c4.05-1.63,8.14-3.37,12.23-5.12l12.27-5.21c16-7.66,31.93-15.73,46.51-26A222.14,222.14,0,0,0,2311.59,565c11.75-13.3,22.27-28.08,27.7-45.36a1,1,0,0,0-.68-1.31,1,1,0,0,0-1.3.68v0Z",
    transform: "translate(-131.41 -117.6)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2029.47,883.36l15.68-9.29c-7.93-122,14.29-345.93,136.14-407,82.54-41.34,113.24-87.43,107.09-185.89-4.11-65.68,17.68-111.08,32.63-134a5.46,5.46,0,0,0-7-7.89c-50.31,24.81-181.4,98.24-241.37,215C1997.57,500.41,2029.47,883.36,2029.47,883.36Z",
    transform: "translate(-131.41 -117.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2236.34,221a133.08,133.08,0,0,0-17.73,12.16c-2.78,2.22-5.58,4.41-8.2,6.8l-4,3.52-2,1.76-1.91,1.84-7.64,7.4c-2.47,2.54-4.86,5.16-7.3,7.73l-3.63,3.88c-1.21,1.29-2.31,2.68-3.47,4l-6.88,8.1c-18,21.84-33.54,45.64-47.31,70.31l-5.18,9.24-1.29,2.32-1.19,2.37-2.37,4.73-9.48,19-8.62,19.36-4.3,9.68c-1.36,3.26-2.59,6.57-3.9,9.85l-7.72,19.73c-1.33,3.27-2.47,6.61-3.64,9.94l-3.52,10c-2.2,6.71-4.41,13.42-6.5,20.17l-3,10.15-1.51,5.08-1.4,5.11c-7.57,27.21-13.82,54.78-18.92,82.55s-9.08,55.73-12.09,83.79c-1.54,14-2.76,28.09-3.85,42.16s-1.84,28.16-2.44,42.26-1,28.21-1.07,42.34,0,28.2.58,42.45a4.65,4.65,0,0,0,9.29-.39v-.11c-.68-13.85-.87-27.93-.88-41.92s.27-28,.76-42,1.2-28,2.13-42,2.09-28,3.51-41.91q4.18-41.85,11.41-83.31T2069.21,507l1.35-5.07,1.47-5.05,2.92-10.09c2-6.7,4.17-13.36,6.3-20l3.42-9.93c1.14-3.31,2.24-6.64,3.54-9.89l7.52-19.62c1.27-3.27,2.47-6.56,3.79-9.8l4.19-9.63,8.41-19.26,9.26-18.85,2.31-4.71,1.16-2.36,1.26-2.3,5.07-9.19c13.45-24.53,28.63-48.18,46.27-69.87l6.73-8c1.13-1.33,2.21-2.71,3.39-4l3.56-3.85c2.38-2.55,4.71-5.15,7.13-7.67l7.46-7.33,1.87-1.83,1.95-1.74,3.9-3.48c2.56-2.37,5.28-4.53,8-6.72s5.51-4.21,8.29-6.29,5.76-3.93,8.63-5.54l.12-.06a2.19,2.19,0,0,0-2.13-3.83Z",
    transform: "translate(-131.41 -117.6)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M551,1445.52H195.57A20.52,20.52,0,0,1,175.05,1425V1081.86a20.52,20.52,0,0,1,20.46-20.52l358.23-1A20.52,20.52,0,0,1,574.32,1081l-2.85,344.1A20.51,20.51,0,0,1,551,1445.52Z",
    transform: "translate(-131.41 -117.6)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M533.54,1086.65l-317.77,1.95a20.81,20.81,0,0,0-20.69,20.92l2.21,288.6a20.82,20.82,0,0,0,20.44,20.72l308.76,5.64a20.83,20.83,0,0,0,21.2-20.53l6.8-296.19A20.82,20.82,0,0,0,533.54,1086.65Z",
    transform: "translate(-131.41 -117.6)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 131.91,
    y: 989.58,
    width: 257.3,
    height: 14.65,
    rx: 6.23
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M493.3,1141h0a6.22,6.22,0,0,1-6.1,5.89l-214.13,3.9a6.23,6.23,0,0,1-6.34-6.23V1144a6.22,6.22,0,0,1,6.13-6.22L487,1134.4A6.23,6.23,0,0,1,493.3,1141Z",
    transform: "translate(-131.41 -117.6)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M515.16,1408.15H515l-289.62-3.47a17.76,17.76,0,0,1-17.53-18.09l7.45-203.79a17.6,17.6,0,0,1,5.44-12.4,17.8,17.8,0,0,1,12.65-5l289.11,5.63a17.77,17.77,0,0,1,17.4,18.06v0l-7,201.59A17.77,17.77,0,0,1,515.16,1408.15ZM233,1171.34A11.85,11.85,0,0,0,221.15,1183l-7.45,203.8a11.85,11.85,0,0,0,11.7,12L515,1402.25h.14A11.87,11.87,0,0,0,527,1390.62L534,1189a11.87,11.87,0,0,0-11.61-12l-289.12-5.62Zm303.91,17.74h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M533.14,1210.66H217.73a3,3,0,0,1,0-5.91H533.14a3,3,0,1,1,0,5.91Z",
    transform: "translate(-131.41 -117.6)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2056.52,1344c0,17.23-13,31.32-28.78,31.32H471.38c-15.83,0-28.78-14.09-28.78-31.32l-13-974c0-17.22,18.63-50.84,52.77-48.32l1521.05-42.85c19.86-.56,39.07,7.76,53.13,23s21.76,36.14,21.29,57.75Z",
    transform: "translate(-131.41 -117.6)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2028.1,1313.91c0,16.31-12.25,29.66-27.22,29.66h-1492c-15,0-27.23-13.35-27.23-29.66L469.46,429.73c1.44-53.21,44.28-72.33,70.24-71.2l1457.79-42.59a48.83,48.83,0,0,1,37.33,16.18,58.17,58.17,0,0,1,15,40.62Z",
    transform: "translate(-131.41 -117.6)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M582,1312.33c-24.06,0-44.07-18.91-44.74-42.41l-23.39-824.7c-.68-23.86,18.68-44,43.15-44.8l1411.48-48.57a45.51,45.51,0,0,1,33.31,12.83,42.71,42.71,0,0,1,13,31.36l-12.07,857.32c-.33,23.84-19.75,42.73-44.21,43l-1376,15.95ZM557.11,402.4l.07,2c-22.3.76-39.94,19-39.33,40.71l23.4,824.71c.6,21.36,18.85,38.56,40.77,38.56h.48l1376-15.95c22.29-.26,40-17.44,40.3-39.11L2010.88,396a38.78,38.78,0,0,0-11.83-28.46,41.49,41.49,0,0,0-30.4-11.7L557.18,404.39Z",
    transform: "translate(-131.41 -117.6)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M224,1252.94H2043.86a7.5,7.5,0,0,1,7.5,7.5V1331a7.51,7.51,0,0,1-7.51,7.51H224a7.51,7.51,0,0,1-7.51-7.51v-70.57A7.51,7.51,0,0,1,224,1252.94Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M582.45,424,1594,400.33c16.45-.39,30.07,9.4,30.07,21.6v11.25c0,11.72-12.6,21.31-28.41,21.61l-1011.12,19c-15.82.3-29.07-8.82-29.85-20.54l-.44-6.53C553.45,434.63,566.15,424.42,582.45,424Z",
    transform: "translate(-131.41 -117.6)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1593.86,427.14c2.15-17.14-9.75-32.74-26.57-34.84s-32.21,10.07-34.36,27.2a31.44,31.44,0,0,0,6.85,23.89l-31.32,24.1a4.36,4.36,0,0,0-.45,6.38l.29.31a4.05,4.05,0,0,0,5.75.15l28.45-28a30.17,30.17,0,0,0,17,8C1576.34,456.45,1591.72,444.27,1593.86,427.14Zm-33.31,18.91a22.91,22.91,0,1,1,25.16-19.93A22.72,22.72,0,0,1,1560.55,446.05Z",
    transform: "translate(-131.41 -117.6)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M563.4,859.53l16.87,377.58c.57,12.72,19.78,22.83,43.07,22.65l495.23-3.72c23.29-.18,42-10.56,41.92-23.29l-1.72-381.11c-.06-13-19.75-23.5-43.61-23.16l-510.38,7.26C581.34,836.08,562.83,846.72,563.4,859.53Z",
    transform: "translate(-131.41 -117.6)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1255.71,501.11l310.46-3.77c31.77-.39,58.12,9.93,58.39,22.87l5.27,256.55c.27,12.92-25.62,23.42-57.39,23.26l-323.2-1.61c-18.19-.1-32.93-6-33.36-13.42l-15.16-260.27C1200,512,1224.55,501.49,1255.71,501.11Z",
    transform: "translate(-131.41 -117.6)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M641.32,495.24l441.79-3.89c45.22-.4,82.71,10.24,83.09,23.57l7.5,264.4c.38,13.32-36.46,24.14-81.67,24l-459.92-1.66c-25.88-.09-46.86-6.21-47.47-13.83L563.07,519.57C562,506.5,597,495.63,641.32,495.24Z",
    transform: "translate(-131.41 -117.6)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1255,831l310.46-5.55c31.78-.56,58.12,14.59,58.39,33.58l5.27,376.68c.27,19-25.62,34.39-57.39,34.16l-323.2-2.37c-18.18-.14-32.93-8.85-33.36-19.71L1200,865.69C1199.25,847.07,1223.81,831.58,1255,831Z",
    transform: "translate(-131.41 -117.6)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1710.74,388.88l242.2-3.9c24.79-.39,45.35,10.26,45.55,23.63l4.12,265c.2,13.35-20,24.19-44.78,24L1705.69,696c-14.19-.09-25.69-6.22-26-13.86l-11.82-268.83C1667.26,400.17,1686.42,389.28,1710.74,388.88Z",
    transform: "translate(-131.41 -117.6)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1716.69,733.21l242.2-3.06c24.79-.31,45.35,8.05,45.55,18.53l4.12,207.92c.2,10.48-20,19-44.78,18.86l-252.14-1.31c-14.19-.07-25.69-4.88-26-10.88l-11.82-210.93C1673.21,742.06,1692.37,733.52,1716.69,733.21Z",
    transform: "translate(-131.41 -117.6)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1728.24,1007.21l242.2-3.26c24.79-.34,45.35,8.57,45.56,19.74l4.11,221.43c.21,11.16-20,20.22-44.78,20.08l-252.14-1.39c-14.19-.08-25.69-5.2-26-11.58l-11.82-224.65C1684.76,1016.64,1703.93,1007.53,1728.24,1007.21Z",
    transform: "translate(-131.41 -117.6)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1592.54,896.7l-1.6,2.16a.65.65,0,0,1-.9.13.64.64,0,0,1-.13-.89h0l1.6-2.14h0a.64.64,0,0,1,.89-.12A.63.63,0,0,1,1592.54,896.7Z",
    transform: "translate(-131.41 -117.6)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1587.12,903.83l-1.68,2.1a.65.65,0,0,1-.92.11.66.66,0,0,1-.1-.93h0l1.67-2.09h0a.64.64,0,0,1,.91-.11A.66.66,0,0,1,1587.12,903.83Z",
    transform: "translate(-131.41 -117.6)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1581.47,910.78l-1.74,2a.67.67,0,0,1-1-.87h0l1.74-2h0a.67.67,0,0,1,.94-.08A.68.68,0,0,1,1581.47,910.78Z",
    transform: "translate(-131.41 -117.6)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1575.6,917.54l-1.8,2a.7.7,0,0,1-1,.05.69.69,0,0,1,0-1h0l1.8-2h0a.69.69,0,0,1,1,.93Z",
    transform: "translate(-131.41 -117.6)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1569.52,924.11l-1.87,1.94a.7.7,0,0,1-1,0,.69.69,0,0,1,0-1h0l1.87-1.92h0a.71.71,0,1,1,1,1Z",
    transform: "translate(-131.41 -117.6)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1563.23,930.49l-1.92,1.87a.73.73,0,1,1-1-1h0l1.92-1.86h0a.73.73,0,0,1,1,0A.72.72,0,0,1,1563.23,930.49Z",
    transform: "translate(-131.41 -117.6)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1556.75,936.67l-2,1.81a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06h0l2-1.8h0a.74.74,0,1,1,1,1.1Z",
    transform: "translate(-131.41 -117.6)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1550.08,942.64l-2,1.75a.77.77,0,1,1-1-1.16h0l2-1.73h0a.76.76,0,0,1,1,1.16Z",
    transform: "translate(-131.41 -117.6)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1543.22,948.41l-2.09,1.68A.78.78,0,0,1,1540,950a.79.79,0,0,1,.12-1.11h0l2.09-1.67h0a.78.78,0,1,1,1,1.22Z",
    transform: "translate(-131.41 -117.6)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1536.19,954l-2.14,1.62a.8.8,0,0,1-1.13-.16.81.81,0,0,1,.15-1.13h0l2.14-1.61h0a.8.8,0,1,1,1,1.28Z",
    transform: "translate(-131.41 -117.6)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1529,959.29l-2.2,1.55a.82.82,0,0,1-1.15-.19.83.83,0,0,1,.2-1.15h0L1528,958h0a.82.82,0,0,1,1,1.34Z",
    transform: "translate(-131.41 -117.6)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1521.62,964.39l-2.24,1.49a.84.84,0,1,1-.93-1.4h0l2.23-1.47h0a.83.83,0,1,1,.92,1.39Z",
    transform: "translate(-131.41 -117.6)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1514.1,969.27l-2.28,1.42a.86.86,0,1,1-.91-1.47h0l2.28-1.4h0a.86.86,0,0,1,1.18.28A.85.85,0,0,1,1514.1,969.27Z",
    transform: "translate(-131.41 -117.6)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1506.44,973.91l-2.33,1.35a.88.88,0,0,1-.88-1.53h0l2.32-1.33h0a.88.88,0,0,1,.87,1.52Z",
    transform: "translate(-131.41 -117.6)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1498.63,978.31l-2.37,1.28a.9.9,0,0,1-.85-1.59h0l2.36-1.26h0a.89.89,0,1,1,.84,1.57Z",
    transform: "translate(-131.41 -117.6)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1490.69,982.47l-2.4,1.2a.92.92,0,0,1-.82-1.64h0l2.4-1.18h0a.91.91,0,0,1,.81,1.63Z",
    transform: "translate(-131.41 -117.6)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1482.63,986.38l-2.45,1.12a.94.94,0,1,1-.78-1.7h0l2.44-1.11h0a.93.93,0,1,1,.78,1.69Z",
    transform: "translate(-131.41 -117.6)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1474.44,990l-2.47,1.05a1,1,0,0,1-.75-1.76h0l2.46-1h0a1,1,0,0,1,1.24.51A.94.94,0,0,1,1474.44,990Z",
    transform: "translate(-131.41 -117.6)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1466.15,993.43l-2.51,1a1,1,0,1,1-.7-1.81h0l2.5-1h0a1,1,0,0,1,.69,1.81Z",
    transform: "translate(-131.41 -117.6)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1457.75,996.56l-2.54.88a1,1,0,1,1-.65-1.87h0l2.52-.87h0a1,1,0,1,1,.65,1.87Z",
    transform: "translate(-131.41 -117.6)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1449.25,999.42l-2.56.8a1,1,0,0,1-.61-1.93h0l2.55-.79h0a1,1,0,0,1,1.25.66A1,1,0,0,1,1449.25,999.42Z",
    transform: "translate(-131.41 -117.6)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1440.67,1002l-2.59.72a1,1,0,0,1-1.27-.71,1,1,0,0,1,.71-1.27h0l2.57-.71h0a1,1,0,0,1,.55,2Z",
    transform: "translate(-131.41 -117.6)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1432,1004.31l-2.61.63a1,1,0,1,1-.5-2h0l2.59-.62h0a1,1,0,1,1,.49,2Z",
    transform: "translate(-131.41 -117.6)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1423.27,1006.33l-2.64.55a1.06,1.06,0,0,1-.44-2.08h0l2.61-.53h0a1.08,1.08,0,0,1,1.26.83A1.06,1.06,0,0,1,1423.27,1006.33Z",
    transform: "translate(-131.41 -117.6)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1414.47,1008.07l-2.65.47a1.09,1.09,0,0,1-.38-2.14h0l2.63-.45h0a1.08,1.08,0,1,1,.37,2.12Z",
    transform: "translate(-131.41 -117.6)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1405.62,1009.53l-2.66.39a1.12,1.12,0,0,1-1.25-.94,1.1,1.1,0,0,1,.94-1.24h0l2.64-.37h0a1.09,1.09,0,0,1,1.24.94A1.08,1.08,0,0,1,1405.62,1009.53Z",
    transform: "translate(-131.41 -117.6)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1396.73,1010.71l-2.67.3a1.13,1.13,0,0,1-1.23-1,1.1,1.1,0,0,1,1-1.22h0l2.65-.28h0a1.11,1.11,0,0,1,.24,2.21Z",
    transform: "translate(-131.41 -117.6)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1387.81,1011.6l-2.68.22a1.12,1.12,0,1,1-.18-2.24h0l2.67-.21h0a1.12,1.12,0,1,1,.17,2.23Z",
    transform: "translate(-131.41 -117.6)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1378.86,1012.22l-2.68.13a1.14,1.14,0,0,1-.11-2.27h0l2.67-.12h0a1.13,1.13,0,1,1,.1,2.26Z",
    transform: "translate(-131.41 -117.6)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1369.9,1012.55l-2.69.05a1.15,1.15,0,0,1,0-2.29h0l2.67,0h0a1.14,1.14,0,1,1,0,2.28Z",
    transform: "translate(-131.41 -117.6)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1360.93,1012.61l-2.69,0a1.16,1.16,0,0,1,0-2.31h0l2.67,0h0a1.16,1.16,0,0,1,0,2.31Z",
    transform: "translate(-131.41 -117.6)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1352,1012.39l-2.69-.12a1.17,1.17,0,0,1,.11-2.33h0l2.67.12h0a1.16,1.16,0,1,1-.11,2.32Z",
    transform: "translate(-131.41 -117.6)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1343,1011.89l-2.69-.2a1.18,1.18,0,0,1,.18-2.35h0l2.67.21h0a1.18,1.18,0,0,1,1.08,1.26A1.17,1.17,0,0,1,1343,1011.89Z",
    transform: "translate(-131.41 -117.6)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1334.07,1011.12l-2.68-.28a1.2,1.2,0,0,1-1.06-1.31,1.19,1.19,0,0,1,1.31-1.06h0l2.65.29h0a1.19,1.19,0,0,1-.25,2.36Z",
    transform: "translate(-131.41 -117.6)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1325.16,1010.07l-2.67-.37a1.2,1.2,0,0,1,.33-2.37h0l2.65.37h0a1.2,1.2,0,0,1,1,1.35A1.19,1.19,0,0,1,1325.16,1010.07Z",
    transform: "translate(-131.41 -117.6)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1316.28,1008.75l-2.65-.45a1.21,1.21,0,0,1,.41-2.39h0l2.63.45h0a1.2,1.2,0,0,1,1,1.39A1.22,1.22,0,0,1,1316.28,1008.75Z",
    transform: "translate(-131.41 -117.6)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1307.46,1007.15l-2.64-.53a1.23,1.23,0,0,1-1-1.44,1.21,1.21,0,0,1,1.44-1h0l2.61.54h0a1.22,1.22,0,0,1-.48,2.39Z",
    transform: "translate(-131.41 -117.6)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1298.68,1005.28l-2.62-.62a1.23,1.23,0,1,1,.57-2.4h0l2.6.62h0a1.23,1.23,0,0,1,.91,1.48A1.24,1.24,0,0,1,1298.68,1005.28Z",
    transform: "translate(-131.41 -117.6)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1290,1003.13l-2.6-.7a1.24,1.24,0,1,1,.65-2.4h0l2.58.7h0a1.24,1.24,0,0,1-.65,2.4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1281.33,1000.71l-2.58-.78a1.25,1.25,0,0,1,.73-2.4h0l2.55.78h0a1.25,1.25,0,0,1-.73,2.4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1272.77,998l-2.55-.86a1.27,1.27,0,0,1,.81-2.41h0l2.52.86h0a1.27,1.27,0,0,1-.81,2.4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1264.3,995.05l-2.52-.94a1.28,1.28,0,1,1,.9-2.39h0l2.5.94h0a1.27,1.27,0,0,1-.9,2.38Z",
    transform: "translate(-131.41 -117.6)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1255.93,991.82l-2.49-1a1.29,1.29,0,1,1,1-2.38h0l2.46,1h0a1.29,1.29,0,1,1-1,2.38Z",
    transform: "translate(-131.41 -117.6)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1247.67,988.31l-2.46-1.1a1.3,1.3,0,0,1,1.07-2.38h0l2.43,1.1h0a1.3,1.3,0,0,1-1.07,2.36Z",
    transform: "translate(-131.41 -117.6)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1239.52,984.54l-2.42-1.19a1.31,1.31,0,1,1,1.15-2.35h0l2.39,1.18h0a1.31,1.31,0,0,1-1.16,2.35Z",
    transform: "translate(-131.41 -117.6)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1231.5,980.5l-2.38-1.26a1.32,1.32,0,0,1,1.24-2.34h0l2.36,1.26h0a1.32,1.32,0,1,1-1.24,2.33Z",
    transform: "translate(-131.41 -117.6)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1223.62,976.21l-2.34-1.34a1.33,1.33,0,1,1,1.32-2.32h0l2.31,1.33h0a1.33,1.33,0,0,1-1.32,2.31Z",
    transform: "translate(-131.41 -117.6)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1215.88,971.66l-2.3-1.42A1.35,1.35,0,1,1,1215,968h0l2.27,1.41h0a1.34,1.34,0,0,1-1.41,2.29Z",
    transform: "translate(-131.41 -117.6)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1208.29,966.86l-2.25-1.49a1.36,1.36,0,0,1,1.5-2.27h0l2.23,1.49h0a1.36,1.36,0,0,1-1.5,2.26Z",
    transform: "translate(-131.41 -117.6)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1200.86,961.81l-2.2-1.57a1.37,1.37,0,1,1,1.59-2.22h0l2.17,1.56h0a1.36,1.36,0,0,1-1.58,2.22Z",
    transform: "translate(-131.41 -117.6)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1193.6,956.51l-2.14-1.63a1.38,1.38,0,0,1,1.67-2.19h0l2.12,1.62h0a1.37,1.37,0,1,1-1.67,2.18Z",
    transform: "translate(-131.41 -117.6)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1186.52,951l-2.08-1.7a1.39,1.39,0,0,1-.2-2,1.4,1.4,0,0,1,2-.2h0l2.06,1.69h0a1.39,1.39,0,1,1-1.76,2.14Z",
    transform: "translate(-131.41 -117.6)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1179.64,945.22l-2-1.78a1.4,1.4,0,0,1,1.84-2.11h0l2,1.77h0a1.4,1.4,0,1,1-1.84,2.1Z",
    transform: "translate(-131.41 -117.6)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1173,939.22l-2-1.85a1.41,1.41,0,0,1,1.93-2.06h0l1.94,1.82h0a1.41,1.41,0,0,1-1.93,2.06Z",
    transform: "translate(-131.41 -117.6)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1166.47,933l-1.9-1.91a1.42,1.42,0,0,1,2-2h0l1.87,1.89h0a1.42,1.42,0,0,1-2,2Z",
    transform: "translate(-131.41 -117.6)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1160.21,926.54l-1.83-2a1.43,1.43,0,1,1,2.1-2h0l1.8,2h0a1.43,1.43,0,1,1-2.1,1.94Z",
    transform: "translate(-131.41 -117.6)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1154.19,919.88l-1.76-2a1.45,1.45,0,0,1,2.19-1.89h0l1.74,2h0a1.45,1.45,0,0,1-.16,2A1.43,1.43,0,0,1,1154.19,919.88Z",
    transform: "translate(-131.41 -117.6)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1148.41,913l-1.69-2.1a1.46,1.46,0,0,1,2.28-1.83h0l1.66,2.08h0a1.45,1.45,0,1,1-2.27,1.82Z",
    transform: "translate(-131.41 -117.6)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1142.88,905.93l-1.61-2.16a1.47,1.47,0,1,1,2.36-1.75h0l1.58,2.14v0a1.46,1.46,0,0,1-2.35,1.74Z",
    transform: "translate(-131.41 -117.6)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1137.61,898.65l-1.52-2.22a1.48,1.48,0,1,1,2.43-1.68h0l1.5,2.2h0a1.48,1.48,0,0,1-2.44,1.67Z",
    transform: "translate(-131.41 -117.6)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1132.62,891.17l-1.44-2.28a1.49,1.49,0,0,1,2.52-1.59h0v0l1.42,2.25v0a1.49,1.49,0,1,1-2.52,1.58Z",
    transform: "translate(-131.41 -117.6)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1127.92,883.51l-1.35-2.33a1.5,1.5,0,1,1,2.59-1.51h0v0l1.33,2.31h0a1.5,1.5,0,1,1-2.59,1.5Z",
    transform: "translate(-131.41 -117.6)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1123.52,875.67l-1.26-2.38a1.51,1.51,0,1,1,2.67-1.41h0v0l1.24,2.35v0a1.5,1.5,0,0,1-2.66,1.4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1119.42,867.68l-1.17-2.43a1.52,1.52,0,1,1,2.74-1.32h0v0l1.15,2.39v0a1.52,1.52,0,0,1-2.74,1.32Z",
    transform: "translate(-131.41 -117.6)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1115.62,859.53l-1.08-2.47a1.53,1.53,0,1,1,2.81-1.23h0l1.06,2.44v0a1.53,1.53,0,0,1-2.81,1.22Z",
    transform: "translate(-131.41 -117.6)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1112.13,851.25l-1-2.51a1.55,1.55,0,0,1,2.88-1.13h0l1,2.48h0a1.54,1.54,0,1,1-2.87,1.13Z",
    transform: "translate(-131.41 -117.6)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1109,842.85l-.9-2.54a1.56,1.56,0,0,1,2.94-1h0l.87,2.51v0a1.56,1.56,0,0,1-1,2A1.54,1.54,0,0,1,1109,842.85Z",
    transform: "translate(-131.41 -117.6)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1106.07,834.33l-.8-2.57a1.57,1.57,0,0,1,3-.93h0v0l.78,2.54v0a1.56,1.56,0,0,1-3,.92Z",
    transform: "translate(-131.41 -117.6)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1103.51,825.72l-.71-2.6a1.58,1.58,0,1,1,3-.83h0l.69,2.57v0a1.57,1.57,0,0,1-3,.82Z",
    transform: "translate(-131.41 -117.6)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1101.25,817l-.62-2.62a1.59,1.59,0,0,1,3.1-.73h0l.6,2.6h0a1.59,1.59,0,1,1-3.09.72Z",
    transform: "translate(-131.41 -117.6)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M1099.3,808.25l-.52-2.64a1.59,1.59,0,0,1,1.26-1.88,1.61,1.61,0,0,1,1.88,1.26h0v0l.51,2.61v0a1.59,1.59,0,0,1-3.13.61Z",
    transform: "translate(-131.41 -117.6)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1097.66,799.42l-.43-2.66a1.61,1.61,0,0,1,3.18-.52h0l.42,2.63v0a1.61,1.61,0,0,1-3.18.51Z",
    transform: "translate(-131.41 -117.6)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1096.34,790.53l-.34-2.68a1.62,1.62,0,1,1,3.22-.4h0v0l.33,2.64v0a1.62,1.62,0,0,1-3.21.4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M1095.32,781.6l-.24-2.69a1.63,1.63,0,1,1,3.25-.3h0l.24,2.66v0a1.63,1.63,0,0,1-3.25.29Z",
    transform: "translate(-131.41 -117.6)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1094.62,772.63l-.15-2.69a1.64,1.64,0,1,1,3.28-.19h0v0l.14,2.66h0a1.64,1.64,0,1,1-3.27.18Z",
    transform: "translate(-131.41 -117.6)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1094.22,763.65l0-2.7a1.66,1.66,0,0,1,3.31-.07h0v0l0,2.66v0a1.66,1.66,0,0,1-3.31.07Z",
    transform: "translate(-131.41 -117.6)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M1094.15,754.65l0-2.69a1.67,1.67,0,1,1,3.33,0h0l0,2.67h0a1.66,1.66,0,1,1-3.32-.05Z",
    transform: "translate(-131.41 -117.6)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M1094.38,745.66l.14-2.69a1.68,1.68,0,1,1,3.35.16h0l-.14,2.66v0a1.68,1.68,0,1,1-3.35-.17Z",
    transform: "translate(-131.41 -117.6)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M1094.94,736.68l.23-2.68a1.69,1.69,0,1,1,3.36.28h0v0l-.23,2.66h0a1.69,1.69,0,1,1-3.36-.29Z",
    transform: "translate(-131.41 -117.6)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1095.81,727.73l.32-2.68a1.7,1.7,0,0,1,3.38.41h0v0l-.32,2.64v0a1.71,1.71,0,0,1-1.9,1.48A1.69,1.69,0,0,1,1095.81,727.73Z",
    transform: "translate(-131.41 -117.6)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1097,718.82l.42-2.67a1.71,1.71,0,1,1,3.38.53h0v0l-.42,2.63v0a1.71,1.71,0,0,1-3.38-.53Z",
    transform: "translate(-131.41 -117.6)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1098.5,710l.51-2.65a1.72,1.72,0,0,1,3.38.65h0v0l-.51,2.61v0a1.72,1.72,0,0,1-3.37-.66Z",
    transform: "translate(-131.41 -117.6)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M1100.32,701.14l.61-2.63a1.73,1.73,0,1,1,3.38.78h0v0l-.6,2.59v0a1.73,1.73,0,0,1-3.37-.79Z",
    transform: "translate(-131.41 -117.6)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M1102.47,692.4l.7-2.6a1.75,1.75,0,0,1,3.37.91h0l-.7,2.57v0a1.74,1.74,0,0,1-3.36-.92Z",
    transform: "translate(-131.41 -117.6)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M1104.93,683.75l.8-2.58a1.76,1.76,0,0,1,3.36,1.05h0v0l-.8,2.54v0a1.76,1.76,0,0,1-3.35-1Z",
    transform: "translate(-131.41 -117.6)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1107.72,675.19l.89-2.54a1.77,1.77,0,0,1,3.34,1.17h0l-.89,2.51v0a1.76,1.76,0,0,1-3.32-1.18Z",
    transform: "translate(-131.41 -117.6)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M1110.82,666.75l1-2.52a1.78,1.78,0,0,1,3.31,1.31h0v0l-1,2.47v0a1.77,1.77,0,1,1-3.3-1.3Z",
    transform: "translate(-131.41 -117.6)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1114.22,658.42l1.08-2.47a1.79,1.79,0,0,1,3.28,1.43h0l-1.07,2.44v0a1.79,1.79,0,0,1-3.27-1.44Z",
    transform: "translate(-131.41 -117.6)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M1117.93,650.22l1.16-2.43a1.8,1.8,0,0,1,3.25,1.56h0l-1.16,2.4h0a1.79,1.79,0,1,1-3.23-1.56Z",
    transform: "translate(-131.41 -117.6)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M1121.92,642.17l1.25-2.39a1.81,1.81,0,0,1,3.21,1.68h0l-1.24,2.35v0a1.81,1.81,0,0,1-3.2-1.68Z",
    transform: "translate(-131.41 -117.6)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M1126.2,634.26l1.33-2.35a1.83,1.83,0,1,1,3.17,1.81h0v0l-1.32,2.31h0a1.83,1.83,0,0,1-2.49.67A1.8,1.8,0,0,1,1126.2,634.26Z",
    transform: "translate(-131.41 -117.6)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M1130.75,626.5l1.41-2.3a1.84,1.84,0,0,1,2.53-.59,1.82,1.82,0,0,1,.59,2.52h0v0l-1.4,2.26v0a1.83,1.83,0,0,1-3.11-1.93Z",
    transform: "translate(-131.41 -117.6)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M1135.56,618.9l1.5-2.24a1.84,1.84,0,0,1,3.07,2h0l-1.48,2.21v0a1.85,1.85,0,0,1-3.07-2.05Z",
    transform: "translate(-131.41 -117.6)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M1140.64,611.48l1.57-2.19a1.85,1.85,0,1,1,3,2.16h0v0l-1.55,2.15v0a1.85,1.85,0,0,1-3-2.16Z",
    transform: "translate(-131.41 -117.6)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1146,604.23l1.64-2.14a1.87,1.87,0,1,1,3,2.28h0v0l-1.63,2.1v0a1.86,1.86,0,0,1-3-2.28Z",
    transform: "translate(-131.41 -117.6)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1151.52,597.17l1.72-2.08a1.88,1.88,0,0,1,2.9,2.38h0l-1.69,2,0,0a1.88,1.88,0,0,1-2.89-2.39Z",
    transform: "translate(-131.41 -117.6)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1157.32,590.3l1.79-2a1.89,1.89,0,1,1,2.83,2.5h0v0l-1.77,2h0a1.88,1.88,0,0,1-2.83-2.49Z",
    transform: "translate(-131.41 -117.6)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M1163.35,583.62l1.85-2a1.9,1.9,0,0,1,2.77,2.6h0l-1.83,1.93h0a1.9,1.9,0,1,1-2.76-2.6Z",
    transform: "translate(-131.41 -117.6)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M1169.6,577.15l1.92-1.9a1.9,1.9,0,1,1,2.68,2.7h0l-1.89,1.87h0a1.9,1.9,0,0,1-2.68-2.7Z",
    transform: "translate(-131.41 -117.6)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1176.07,570.89l2-1.83a1.9,1.9,0,1,1,2.59,2.79h0l-2,1.81h0a1.91,1.91,0,1,1-2.59-2.8Z",
    transform: "translate(-131.41 -117.6)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M1182.74,564.85l2-1.77a1.91,1.91,0,0,1,2.5,2.89h0v0l-2,1.74h0a1.91,1.91,0,0,1-2.5-2.89Z",
    transform: "translate(-131.41 -117.6)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1189.61,559l2.1-1.7a1.91,1.91,0,1,1,2.41,3h0L1192,562h0a1.91,1.91,0,1,1-2.41-3Z",
    transform: "translate(-131.41 -117.6)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1196.67,553.46l2.15-1.63a1.92,1.92,0,1,1,2.31,3.06h0l-2.13,1.6v0a1.92,1.92,0,1,1-2.31-3.06Z",
    transform: "translate(-131.41 -117.6)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1203.91,548.11l2.21-1.55a1.92,1.92,0,0,1,2.21,3.14h0l-2.17,1.53h0a1.92,1.92,0,1,1-2.21-3.14Z",
    transform: "translate(-131.41 -117.6)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M1211.33,543l2.25-1.48a1.92,1.92,0,1,1,2.11,3.22h0l-2.23,1.46h0a1.92,1.92,0,1,1-2.1-3.22Z",
    transform: "translate(-131.41 -117.6)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M1218.91,538.17l2.31-1.4a1.93,1.93,0,1,1,2,3.3h0l-2.27,1.38h0a1.93,1.93,0,1,1-2-3.3Z",
    transform: "translate(-131.41 -117.6)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1226.66,533.59l2.35-1.32a1.93,1.93,0,1,1,1.89,3.37h0l-2.32,1.3h0a1.93,1.93,0,1,1-1.89-3.37Z",
    transform: "translate(-131.41 -117.6)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1234.55,529.28,1237,528a1.93,1.93,0,1,1,1.78,3.43h0l-2.36,1.23h0a1.93,1.93,0,1,1-1.78-3.43Z",
    transform: "translate(-131.41 -117.6)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1242.6,525.24l2.44-1.16a1.94,1.94,0,0,1,1.66,3.51h0l-2.41,1.13h0a1.94,1.94,0,0,1-1.66-3.5Z",
    transform: "translate(-131.41 -117.6)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1250.78,521.48l2.48-1.07a1.94,1.94,0,0,1,1.54,3.57h0l-2.45,1h0a1.94,1.94,0,0,1-1.53-3.57Z",
    transform: "translate(-131.41 -117.6)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1259.08,518l2.52-1a1.95,1.95,0,0,1,1.42,3.63h0l-2.48,1h0a1.94,1.94,0,0,1-1.42-3.62Z",
    transform: "translate(-131.41 -117.6)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1267.51,514.84l2.54-.89a2,2,0,1,1,1.3,3.68h0l-2.51.87h0a1.95,1.95,0,1,1-1.29-3.68Z",
    transform: "translate(-131.41 -117.6)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1276,512l2.58-.8a2,2,0,0,1,1.16,3.73h0l-2.54.8h0A2,2,0,1,1,1276,512Z",
    transform: "translate(-131.41 -117.6)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1284.65,509.38l2.6-.72a2,2,0,1,1,1,3.77h0l-2.56.71h0a2,2,0,1,1-1-3.77Z",
    transform: "translate(-131.41 -117.6)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1293.35,507.09l2.62-.63a2,2,0,0,1,.92,3.81h0l-2.58.62h0a2,2,0,0,1-.91-3.81Z",
    transform: "translate(-131.41 -117.6)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1302.12,505.09l2.64-.54a2,2,0,1,1,.79,3.84h0l-2.61.53h0a2,2,0,1,1-.79-3.84Z",
    transform: "translate(-131.41 -117.6)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1311,503.38l2.66-.45a2,2,0,1,1,.66,3.87h0l-2.62.44h0a2,2,0,1,1-.66-3.88Z",
    transform: "translate(-131.41 -117.6)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M1319.83,502l2.67-.36a2,2,0,1,1,.54,3.9h0l-2.63.37h0a2,2,0,0,1-.54-3.91Z",
    transform: "translate(-131.41 -117.6)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M1328.75,500.84l2.69-.28a2,2,0,1,1,.41,3.92h0l-2.65.27h0a2,2,0,0,1-.41-3.92Z",
    transform: "translate(-131.41 -117.6)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1337.71,500l2.69-.19a2,2,0,1,1,.29,3.94h0l-2.65.19h0a2,2,0,0,1-.28-3.95Z",
    transform: "translate(-131.41 -117.6)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M1346.68,499.45l2.7-.11a2,2,0,0,1,.16,4h0l-2.66.1h0a2,2,0,0,1-.16-4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1355.67,499.19l2.7,0a2,2,0,1,1,0,4h0l-2.66,0h0a2,2,0,0,1,0-4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M1364.67,499.22l2.7.06a2,2,0,0,1-.1,4h0l-2.66-.07h0a2,2,0,1,1,.1-4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M1373.66,499.53l2.69.15a2,2,0,0,1-.22,4h0l-2.65-.14h0a2,2,0,1,1,.22-4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M1382.63,500.12l2.69.24a2,2,0,1,1-.34,4h0l-2.65-.23h0a2,2,0,1,1,.34-4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M1391.59,501l2.68.32a2,2,0,1,1-.47,4h0l-2.65-.32h0a2,2,0,0,1,.47-4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1400.51,502.16l2.67.41a2,2,0,0,1-.6,4h0l-2.63-.4h0a2,2,0,0,1,.6-4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M1409.39,503.61l2.66.49a2,2,0,1,1-.73,3.94h0l-2.61-.48h0a2,2,0,0,1,.72-3.94Z",
    transform: "translate(-131.41 -117.6)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1418.23,505.33l2.63.58a2,2,0,1,1-.85,3.93h0l-2.6-.57h0a2,2,0,0,1,.86-3.93Z",
    transform: "translate(-131.41 -117.6)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M1427,507.34l2.62.66a2,2,0,0,1-1,3.9h0l-2.58-.65h0a2,2,0,0,1,1-3.9Z",
    transform: "translate(-131.41 -117.6)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1435.7,509.63l2.6.74a2,2,0,1,1-1.11,3.88h0l-2.56-.73h0a2,2,0,1,1,1.11-3.87Z",
    transform: "translate(-131.41 -117.6)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M1444.33,512.19l2.57.83a2,2,0,1,1-1.24,3.85h0l-2.53-.81h0a2,2,0,0,1,1.24-3.85Z",
    transform: "translate(-131.41 -117.6)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M1452.87,515l2.54.9a2,2,0,0,1-1.36,3.82h0l-2.51-.9h0a2,2,0,0,1,1.37-3.81Z",
    transform: "translate(-131.41 -117.6)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M1461.31,518.16l2.51,1a2,2,0,0,1-1.49,3.77h0l-2.47-1h0a2,2,0,1,1,1.49-3.77Z",
    transform: "translate(-131.41 -117.6)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1469.64,521.56l2.48,1.07a2,2,0,0,1-1.62,3.73h0l-2.44-1.06h0a2,2,0,0,1,1.62-3.72Z",
    transform: "translate(-131.41 -117.6)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M1477.86,525.23l2.44,1.15a2,2,0,0,1-1.74,3.68h0l-2.41-1.14h0a2,2,0,0,1,1.74-3.68Z",
    transform: "translate(-131.41 -117.6)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M1486,529.15l2.41,1.22a2,2,0,1,1-1.84,3.63h0l-2.38-1.21h0a2,2,0,1,1,1.84-3.63Z",
    transform: "translate(-131.41 -117.6)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M1493.93,533.27l2.38,1.27a2,2,0,0,1-1.93,3.6h0l-2.35-1.26h0a2,2,0,0,1,1.93-3.6Z",
    transform: "translate(-131.41 -117.6)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M1501.81,537.56l2.35,1.32a2,2,0,1,1-2,3.57h0l-2.33-1.31h0a2,2,0,0,1,2-3.57Z",
    transform: "translate(-131.41 -117.6)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M1509.61,542l2.32,1.35a2,2,0,0,1-2,3.55h0l-2.31-1.34h0a2.05,2.05,0,0,1,2.06-3.55Z",
    transform: "translate(-131.41 -117.6)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M1517.34,546.51l2.31,1.37a2.05,2.05,0,0,1-2.1,3.53h0l-2.29-1.37h0a2.05,2.05,0,0,1,2.1-3.53Z",
    transform: "translate(-131.41 -117.6)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M1525,551.1l2.3,1.39a2.06,2.06,0,0,1-2.13,3.52h0l-2.29-1.39a2.05,2.05,0,1,1,2.12-3.52Z",
    transform: "translate(-131.41 -117.6)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1532.67,555.73l2.29,1.39a2.06,2.06,0,0,1-2.14,3.52h0l-2.29-1.39a2.06,2.06,0,1,1,2.14-3.52Z",
    transform: "translate(-131.41 -117.6)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1540.3,560.36l2.3,1.39a2.06,2.06,0,1,1-2.14,3.53h0l-2.29-1.39a2.06,2.06,0,0,1,2.13-3.53Z",
    transform: "translate(-131.41 -117.6)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M1548,565l2.29,1.37h0a2.07,2.07,0,0,1-2.12,3.55h0l-2.3-1.38a2.06,2.06,0,0,1,2.12-3.54Z",
    transform: "translate(-131.41 -117.6)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M1555.61,569.52l2.31,1.35h0a2.08,2.08,0,0,1-2.1,3.58h0l-2.32-1.36a2.07,2.07,0,1,1,2.1-3.57Z",
    transform: "translate(-131.41 -117.6)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1563.32,574l2.32,1.32h0a2.07,2.07,0,1,1-2,3.61h0l-2.34-1.33a2.07,2.07,0,1,1,2-3.6Z",
    transform: "translate(-131.41 -117.6)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M1571.09,578.32l2.34,1.27h0a2.08,2.08,0,1,1-2,3.65h0l-2.37-1.29a2.08,2.08,0,0,1,2-3.65Z",
    transform: "translate(-131.41 -117.6)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1578.93,582.5l2.37,1.22h0a2.08,2.08,0,1,1-1.91,3.7h0l-2.4-1.24a2.08,2.08,0,0,1,1.91-3.7Z",
    transform: "translate(-131.41 -117.6)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M1586.87,586.49l2.4,1.15h0a2.09,2.09,0,1,1-1.81,3.76h0l-2.43-1.17a2.09,2.09,0,0,1,1.81-3.76Z",
    transform: "translate(-131.41 -117.6)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M1594.9,590.25l2.43,1.08h0a2.09,2.09,0,0,1-1.69,3.82h0l-2.46-1.1a2.09,2.09,0,0,1,1.69-3.82Z",
    transform: "translate(-131.41 -117.6)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M1603,593.74l2.47,1h0a2.1,2.1,0,0,1-1.56,3.89h0l-2.51-1a2.1,2.1,0,0,1-1.16-2.73,2.08,2.08,0,0,1,2.72-1.15Z",
    transform: "translate(-131.41 -117.6)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M1611.3,596.93l2.5.9h0a2.09,2.09,0,1,1-1.41,3.94h0l-2.55-.91a2.09,2.09,0,0,1,1.42-3.94Z",
    transform: "translate(-131.41 -117.6)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M1619.67,599.78l2.53.79h0a2.1,2.1,0,0,1-1.24,4h0l-2.59-.8a2.1,2.1,0,1,1,1.25-4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M1628.15,602.25l2.57.66h0a2.1,2.1,0,0,1-1,4.07h0l-2.62-.68a2.1,2.1,0,1,1,1-4.07Z",
    transform: "translate(-131.41 -117.6)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M1636.74,604.29l2.59.53h0a2.11,2.11,0,0,1-.84,4.13h0l-2.65-.55a2.1,2.1,0,1,1,.84-4.12Z",
    transform: "translate(-131.41 -117.6)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M1645.42,605.9l2.61.39h0a2.11,2.11,0,0,1-.63,4.18h0l-2.68-.41a2.11,2.11,0,1,1,.62-4.17Z",
    transform: "translate(-131.41 -117.6)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M1654.16,607l2.63.25h0a2.11,2.11,0,0,1-.4,4.21h0l-2.7-.26a2.11,2.11,0,1,1,.4-4.21Z",
    transform: "translate(-131.41 -117.6)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M1663,607.69l2.64.1h0a2.12,2.12,0,0,1-.16,4.23h0l-2.72-.1a2.12,2.12,0,0,1,.16-4.23Z",
    transform: "translate(-131.41 -117.6)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M1671.75,607.84l2.64-.06h0a2.12,2.12,0,1,1,.1,4.24h0l-2.72.06a2.12,2.12,0,1,1-.09-4.24Z",
    transform: "translate(-131.41 -117.6)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M1680.55,607.45l2.63-.23h0a2.12,2.12,0,1,1,.36,4.23h0l-2.71.23a2.12,2.12,0,1,1-.36-4.23Z",
    transform: "translate(-131.41 -117.6)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M1689.29,606.5l2.6-.4h0a2.13,2.13,0,1,1,.65,4.21h0l-2.69.41a2.13,2.13,0,0,1-.64-4.21Z",
    transform: "translate(-131.41 -117.6)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M1697.93,605l2.57-.58h0a2.13,2.13,0,1,1,.94,4.16h0l-2.66.6a2.13,2.13,0,0,1-.93-4.16Z",
    transform: "translate(-131.41 -117.6)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M1706.44,602.82l2.52-.77h0a2.14,2.14,0,1,1,1.24,4.09h0l-2.61.79a2.14,2.14,0,0,1-1.23-4.09Z",
    transform: "translate(-131.41 -117.6)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M1714.76,600.05l2.44-1h0a2.14,2.14,0,1,1,1.56,4h0l-2.55,1a2.14,2.14,0,0,1-1.55-4Z",
    transform: "translate(-131.41 -117.6)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M1722.82,596.63l2.36-1.15,0,0a2.14,2.14,0,0,1,1.88,3.85h0l-2.46,1.2a2.14,2.14,0,0,1-1.87-3.86Z",
    transform: "translate(-131.41 -117.6)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1730.58,592.57l2.27-1.33,0,0a2.14,2.14,0,1,1,2.18,3.69h0l-2.35,1.38a2.14,2.14,0,1,1-2.18-3.69Z",
    transform: "translate(-131.41 -117.6)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M1738,587.91l2.15-1.52,0,0a2.15,2.15,0,1,1,2.48,3.51h0l-2.23,1.58a2.15,2.15,0,1,1-2.48-3.52Z",
    transform: "translate(-131.41 -117.6)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M1745,582.65l2-1.69,0,0a2.15,2.15,0,1,1,2.76,3.3h0l-2.09,1.75a2.15,2.15,0,0,1-2.77-3.3Z",
    transform: "translate(-131.41 -117.6)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M1751.53,576.83l1.86-1.85,0,0a2.16,2.16,0,1,1,3,3.06h0l-1.94,1.93a2.16,2.16,0,0,1-3-3.06Z",
    transform: "translate(-131.41 -117.6)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M1757.53,570.47l1.68-2,0,0a2.16,2.16,0,1,1,3.31,2.78h0l-1.77,2.1a2.16,2.16,0,1,1-3.3-2.78Z",
    transform: "translate(-131.41 -117.6)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M1762.93,563.61l1.48-2.15,0-.06a2.17,2.17,0,0,1,3.56,2.47h0l-1.56,2.25a2.16,2.16,0,0,1-3.56-2.46Z",
    transform: "translate(-131.41 -117.6)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M1767.64,556.27l1.27-2.28,0-.06a2.16,2.16,0,1,1,3.78,2.11h0l-1.33,2.4a2.17,2.17,0,1,1-3.79-2.11Z",
    transform: "translate(-131.41 -117.6)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M1771.61,548.52l1-2.4,0-.07a2.17,2.17,0,1,1,4,1.72h0l-1.08,2.52a2.17,2.17,0,1,1-4-1.71Z",
    transform: "translate(-131.41 -117.6)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M1774.74,540.4l.76-2.49,0-.07a2.17,2.17,0,1,1,4.15,1.27h0l-.81,2.64a2.17,2.17,0,1,1-4.15-1.28Z",
    transform: "translate(-131.41 -117.6)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M1776.94,532l.48-2.57v-.07a2.18,2.18,0,1,1,4.28.79h0l-.5,2.71a2.18,2.18,0,0,1-4.28-.79Z",
    transform: "translate(-131.41 -117.6)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M1778.18,523.41l.19-2.6v-.08a2.19,2.19,0,0,1,4.36.32h0l-.2,2.74a2.18,2.18,0,1,1-4.35-.31Z",
    transform: "translate(-131.41 -117.6)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M1778.47,514.72l-.09-2.61V512a2.19,2.19,0,0,1,4.37-.16h0l.1,2.75a2.19,2.19,0,0,1-4.37.16Z",
    transform: "translate(-131.41 -117.6)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M1777.83,506.05l-.38-2.58v-.07a2.18,2.18,0,1,1,4.32-.63l.39,2.72a2.18,2.18,0,0,1-4.31.63h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M1776.25,497.5l-.66-2.52v-.08a2.17,2.17,0,0,1,4.21-1.09l.69,2.66a2.18,2.18,0,1,1-4.21,1.1h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M1773.74,489.18l-.93-2.43,0-.07a2.17,2.17,0,0,1,4.06-1.56l1,2.57a2.17,2.17,0,1,1-4.06,1.56h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M1770.3,481.22l-1.21-2.3,0-.07a2.17,2.17,0,1,1,3.84-2l1.29,2.44a2.17,2.17,0,1,1-3.84,2h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M1765.94,473.74l-1.49-2.13,0-.07a2.17,2.17,0,1,1,3.56-2.48l1.58,2.26a2.17,2.17,0,1,1-3.55,2.49h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M1760.67,466.88l-1.75-1.91-.06-.06a2.17,2.17,0,0,1,3.19-2.93l1.87,2a2.17,2.17,0,1,1-3.19,2.93h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1754.54,460.81l-2-1.65-.07-.06a2.16,2.16,0,0,1,2.75-3.33l2.14,1.76a2.16,2.16,0,0,1-2.75,3.34h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M1747.62,455.7l-2.22-1.33-.08-.05a2.15,2.15,0,1,1,2.21-3.7l2.39,1.42a2.16,2.16,0,1,1-2.21,3.71h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M1740,451.68l-2.39-1-.09,0a2.15,2.15,0,1,1,1.65-4l2.56,1.06a2.15,2.15,0,1,1-1.64,4h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M1731.88,448.77l-2.5-.65-.09,0a2.15,2.15,0,0,1,1.08-4.17l2.68.7a2.15,2.15,0,1,1-1.08,4.16h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M1723.43,447l-2.58-.31h-.08a2.15,2.15,0,0,1,.52-4.27l2.74.33a2.15,2.15,0,1,1-.51,4.27h-.09Z",
    transform: "translate(-131.41 -117.6)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M1714.81,446.34l-2.6,0h-.08a2.13,2.13,0,0,1-2.17-2.12,2.16,2.16,0,0,1,2.12-2.17l2.77,0a2.15,2.15,0,1,1,.05,4.29h-.09Z",
    transform: "translate(-131.41 -117.6)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M1706.18,446.84l-2.56.38h-.09a2.14,2.14,0,1,1-.62-4.24l2.74-.4a2.14,2.14,0,0,1,.62,4.24h-.09Z",
    transform: "translate(-131.41 -117.6)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M1697.72,448.5l-2.48.74-.09,0a2.14,2.14,0,1,1-1.21-4.1l2.66-.79a2.14,2.14,0,0,1,1.21,4.11h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M1689.6,451.36l-2.34,1.1-.09,0a2.14,2.14,0,1,1-1.81-3.87l2.52-1.18a2.14,2.14,0,1,1,1.81,3.87h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M1682,455.43l-2.12,1.45-.09.06a2.13,2.13,0,1,1-2.41-3.52l2.3-1.57a2.13,2.13,0,0,1,2.41,3.51h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M1675.28,460.67l-1.84,1.79-.08.08a2.13,2.13,0,0,1-3-3.05l2-1.95a2.13,2.13,0,0,1,3,3h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M1669.57,467l-1.46,2.1-.08.1a2.12,2.12,0,1,1-3.48-2.43l1.6-2.3a2.13,2.13,0,1,1,3.49,2.43h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M1665.17,474.3l-1.06,2.34,0,.1a2.12,2.12,0,1,1-3.87-1.74l1.14-2.55a2.12,2.12,0,0,1,3.87,1.74h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M1662.14,482.3l-.64,2.5,0,.1a2.12,2.12,0,0,1-4.11-1.06l.7-2.7a2.12,2.12,0,0,1,4.1,1.06h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M1660.47,490.72l-.24,2.57v.1A2.11,2.11,0,0,1,1656,493l.25-2.77a2.12,2.12,0,0,1,4.22.39h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M1660.14,499.32l.16,2.57v.1a2.11,2.11,0,0,1-4.22.26l-.17-2.77a2.11,2.11,0,1,1,4.22-.26h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M1661.12,507.86l.55,2.52,0,.1a2.11,2.11,0,0,1-4.12.9l-.59-2.71a2.11,2.11,0,1,1,4.12-.91h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M1663.42,516.14l.95,2.39,0,.1a2.1,2.1,0,0,1-3.91,1.55l-1-2.59a2.11,2.11,0,1,1,3.92-1.55h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M1667,523.89l1.34,2.19.06.1a2.1,2.1,0,1,1-3.58,2.2L1663.4,526a2.1,2.1,0,0,1,3.58-2.21h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M1672,530.84l1.73,1.87.08.1a2.1,2.1,0,0,1-3.08,2.85l-1.91-2.07a2.1,2.1,0,0,1,3.09-2.85h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M1678.16,536.64l2.08,1.47.11.08a2.09,2.09,0,0,1-2.42,3.42l-2.3-1.62a2.1,2.1,0,0,1,2.42-3.43h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1034,918.81l-323.16-2.9a11.36,11.36,0,0,0-11.46,11.42l1.41,248a11.35,11.35,0,0,0,11.69,11.29c58.43-1.74,317.84-9.43,329.29-8.95s5.17-198.73,3.48-247.88A11.35,11.35,0,0,0,1034,918.81Z",
    transform: "translate(-131.41 -117.6)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M712.14,1177.05a1.79,1.79,0,0,1-1.8-1.79l-1.42-248a1.75,1.75,0,0,1,.53-1.28,1.79,1.79,0,0,1,1.29-.53l323.16,2.89a1.8,1.8,0,0,1,1.79,1.74c4.17,121.5,4.26,214.77.21,237.61l-.07.4h-.41c-42.83.6-276.75,7.54-323.23,8.93Zm-1.41-250.59a.78.78,0,0,0-.58.24.76.76,0,0,0-.24.57l1.42,248a.8.8,0,0,0,.79.81l0,.49,0-.49c46.32-1.38,278.93-8.29,322.84-8.93,4-23.45,3.86-116.26-.29-237a.81.81,0,0,0-.81-.77Z",
    transform: "translate(-131.41 -117.6)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M995,1145.37H783.15a8.52,8.52,0,0,1-7.35-12.85L859.66,990a8.53,8.53,0,0,1,15.11.78l40.49,88.73a8.53,8.53,0,0,0,13.52,2.75l16.38-15a8.54,8.54,0,0,1,12.77,1.42L1002,1132A8.53,8.53,0,0,1,995,1145.37Z",
    transform: "translate(-131.41 -117.6)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-231",
    cx: 786.03,
    cy: 985.64,
    r: 30.45,
    transform: "translate(-598.14 726.89) rotate(-45)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M541,605.59a1.76,1.76,0,0,1-2.92-1.16c-.21-2.34-.37-4.72-.48-7.06a1.75,1.75,0,0,1,3.5-.18c.12,2.3.28,4.64.48,6.94A1.78,1.78,0,0,1,541,605.59Z",
    transform: "translate(-131.41 -117.6)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M834.93,441.6a1.75,1.75,0,0,1-2.22.1c-3.81-2.83-7.78-5.55-11.79-8.08a1.75,1.75,0,1,1,1.86-3c4.1,2.58,8.14,5.35,12,8.24a1.75,1.75,0,0,1,.35,2.45A1.43,1.43,0,0,1,834.93,441.6Zm-32.5-19.34a1.75,1.75,0,0,1-1.92.29c-4.29-2-8.73-3.83-13.2-5.48a1.76,1.76,0,0,1,1.22-3.3c4.55,1.69,9.08,3.57,13.46,5.6a1.75,1.75,0,0,1,.85,2.33A1.66,1.66,0,0,1,802.43,422.26ZM766.65,410a1.76,1.76,0,0,1-1.57.41c-4.64-1.09-9.36-2-14-2.72a1.76,1.76,0,0,1,.53-3.47c4.77.73,9.59,1.66,14.31,2.77a1.75,1.75,0,0,1,1.3,2.11A1.69,1.69,0,0,1,766.65,410ZM540.89,575.15a1.75,1.75,0,0,1-1.32.45,1.77,1.77,0,0,1-1.61-1.89c.39-4.82,1-9.68,1.73-14.47a1.76,1.76,0,1,1,3.47.55c-.75,4.7-1.32,9.47-1.7,14.19A1.73,1.73,0,0,1,540.89,575.15Zm188.25-170a1.75,1.75,0,0,1-1.22.45c-4.74-.12-9.54-.05-14.28.21a1.75,1.75,0,0,1-.19-3.5c4.83-.27,9.73-.34,14.56-.22a1.75,1.75,0,0,1,1.71,1.8A1.72,1.72,0,0,1,729.14,405.17ZM547.74,537.94a1.75,1.75,0,0,1-2.86-1.79c1.35-4.66,2.91-9.3,4.61-13.82a1.75,1.75,0,1,1,3.28,1.24c-1.67,4.43-3.19,9-4.52,13.56A1.79,1.79,0,0,1,547.74,537.94ZM691.45,408.16a1.71,1.71,0,0,1-.85.42c-4.65.86-9.34,1.91-13.94,3.14a1.75,1.75,0,1,1-.9-3.39c4.68-1.25,9.46-2.33,14.2-3.2a1.75,1.75,0,0,1,1.49,3ZM562,502.89a1.73,1.73,0,0,1-2,.25,1.76,1.76,0,0,1-.73-2.37c2.28-4.28,4.75-8.51,7.34-12.59a1.76,1.76,0,1,1,3,1.89c-2.54,4-5,8.15-7.19,12.34A1.65,1.65,0,0,1,562,502.89Zm93.21-84.09a1.91,1.91,0,0,1-.51.32c-4.39,1.79-8.77,3.78-13,5.91a1.75,1.75,0,1,1-1.58-3.13c4.32-2.18,8.79-4.2,13.26-6a1.76,1.76,0,0,1,1.84,2.93ZM621.8,436.59a1.56,1.56,0,0,1-.2.16c-3.93,2.64-7.81,5.48-11.54,8.43a1.76,1.76,0,0,1-2.47-.29,1.8,1.8,0,0,1,.29-2.47c3.8-3,7.76-5.89,11.77-8.59a1.75,1.75,0,0,1,2.15,2.76ZM583.06,471.5a1.75,1.75,0,0,1-2.52-2.43c3.1-3.71,6.38-7.35,9.76-10.81a1.77,1.77,0,0,1,2.49,0,1.75,1.75,0,0,1,0,2.48c-3.31,3.39-6.54,7-9.58,10.6A1,1,0,0,1,583.06,471.5Z",
    transform: "translate(-131.41 -117.6)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M857.81,461.79a1.76,1.76,0,0,1-2.45-.09c-1.59-1.66-3.24-3.31-4.9-4.92a1.74,1.74,0,0,1,0-2.48,1.77,1.77,0,0,1,2.48,0c1.69,1.63,3.37,3.32,5,5a1.77,1.77,0,0,1,0,2.49Z",
    transform: "translate(-131.41 -117.6)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M909.15,596.21a1.77,1.77,0,0,1-1.24.45,1.76,1.76,0,0,1-1.69-1.82c.09-2.32.13-4.66.12-7a1.76,1.76,0,0,1,3.51,0c0,2.34,0,4.72-.12,7.09A1.77,1.77,0,0,1,909.15,596.21Z",
    transform: "translate(-131.41 -117.6)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M848.48,726.43l-1.18,1.06a1.76,1.76,0,0,1-2.34-2.62h0l1.16-1c3.08-2.78,6.11-5.71,9-8.7a1.77,1.77,0,0,1,2.48,0,1.74,1.74,0,0,1,0,2.48C854.71,720.62,851.62,723.6,848.48,726.43Zm-19.34,15.25a1.33,1.33,0,0,1-.19.14c-3.92,2.69-8,5.26-12.12,7.65a1.76,1.76,0,0,1-1.76-3.05c4-2.33,8-4.86,11.9-7.49a1.75,1.75,0,0,1,2.44.45A1.77,1.77,0,0,1,829.14,741.68Zm43.38-41.58a1.76,1.76,0,0,1-2.58-2.36c2.8-3.74,5.48-7.64,8-11.57a1.75,1.75,0,1,1,3,1.87c-2.55,4-5.29,8-8.14,11.81A2.73,2.73,0,0,1,872.52,700.1Zm-76,59.43a1.86,1.86,0,0,1-.5.32c-4.39,1.85-8.9,3.56-13.4,5.06a1.76,1.76,0,0,1-1.12-3.33c4.42-1.47,8.85-3.15,13.16-5a1.76,1.76,0,0,1,1.86,2.92Zm95.19-91.34a1.78,1.78,0,0,1-1.93.28,1.76,1.76,0,0,1-.84-2.33c2-4.21,3.82-8.57,5.48-13a1.76,1.76,0,1,1,3.29,1.25c-1.7,4.47-3.58,8.91-5.59,13.2A1.93,1.93,0,0,1,891.68,668.19ZM760.92,770.5a1.68,1.68,0,0,1-.82.41c-4.66.94-9.42,1.7-14.15,2.27a1.75,1.75,0,0,1-.42-3.48c4.63-.56,9.3-1.31,13.88-2.23a1.76,1.76,0,0,1,1.51,3ZM904,633.07a1.75,1.75,0,0,1-2.88-1.71c1.1-4.54,2-9.18,2.8-13.79a1.75,1.75,0,1,1,3.46.57c-.76,4.69-1.72,9.42-2.85,14A1.72,1.72,0,0,1,904,633.07Zm-180.14,141a1.72,1.72,0,0,1-1.18.45c-4.75,0-9.57-.24-14.32-.63a1.76,1.76,0,0,1,.29-3.5c4.67.39,9.39.6,14.05.62a1.75,1.75,0,0,1,1.74,1.77A1.72,1.72,0,0,1,723.89,774.07Zm-37-4a1.77,1.77,0,0,1-1.54.41c-3.67-.77-7.36-1.67-11-2.66-1-.27-2-.54-2.92-.83a1.75,1.75,0,0,1,1-3.37c1,.28,1.91.55,2.87.81,3.56,1,7.19,1.86,10.78,2.62a1.76,1.76,0,0,1,1.36,2.08A1.81,1.81,0,0,1,686.9,770.1Zm-35.48-11.27a1.74,1.74,0,0,1-1.87.31c-4.37-1.89-8.72-4-12.93-6.19a1.76,1.76,0,1,1,1.63-3.11c4.13,2.18,8.4,4.22,12.69,6.07a1.75,1.75,0,0,1,.91,2.31A1.69,1.69,0,0,1,651.42,758.83Zm-32.5-18.15a1.74,1.74,0,0,1-2.18.13c-3.89-2.73-7.73-5.65-11.41-8.67a1.75,1.75,0,0,1,2.23-2.71c3.61,3,7.38,5.83,11.2,8.51a1.76,1.76,0,0,1,.43,2.44A1.93,1.93,0,0,1,618.92,740.68Z",
    transform: "translate(-131.41 -117.6)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M590.72,716.29a1.76,1.76,0,0,1-2.45-.1c-1.61-1.7-3.21-3.47-4.76-5.25a1.82,1.82,0,0,1,.16-2.47,1.76,1.76,0,0,1,2.48.16c1.53,1.75,3.1,3.48,4.67,5.15a1.75,1.75,0,0,1-.07,2.48Z",
    transform: "translate(-131.41 -117.6)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M606.1,667.43a2.21,2.21,0,0,0,2.29,1.16L635,664.46a117.13,117.13,0,0,0,29.26,24.28l.87,26.91a2.2,2.2,0,0,0,1.56,2l30.88,9.54a2.2,2.2,0,0,0,2.44-.81l15.9-21.73a117.37,117.37,0,0,0,37.85-3.54l19.66,18.42a2.23,2.23,0,0,0,2.55.34l28.58-15.09a2.21,2.21,0,0,0,1.15-2.3L801.6,675.9a117.71,117.71,0,0,0,24.28-29.26l26.91-.88a2.2,2.2,0,0,0,2-1.56l9.54-30.87a2.21,2.21,0,0,0-.81-2.44L841.83,595a117.41,117.41,0,0,0-3.55-37.86l18.42-19.66a2.2,2.2,0,0,0,.34-2.55L842,506.35a2.21,2.21,0,0,0-2.29-1.16L813,509.32A117.13,117.13,0,0,0,783.77,485l-.87-26.91a2.2,2.2,0,0,0-1.56-2l-30.88-9.54a2.2,2.2,0,0,0-2.44.81l-15.9,21.73a117.37,117.37,0,0,0-37.85,3.54l-19.66-18.42a2.23,2.23,0,0,0-2.55-.34L643.48,469a2.21,2.21,0,0,0-1.15,2.3l4.12,26.62a117.71,117.71,0,0,0-24.28,29.26l-26.91.88a2.2,2.2,0,0,0-2,1.56l-9.54,30.87a2.21,2.21,0,0,0,.81,2.44l21.73,15.9a117.41,117.41,0,0,0,3.55,37.86l-18.42,19.66a2.2,2.2,0,0,0-.34,2.55Z",
    transform: "translate(-131.41 -117.6)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M745,610.15l0,0a31.32,31.32,0,1,1,10.32-21.64A31.17,31.17,0,0,1,745,610.17Zm-38.44-42.61a26.06,26.06,0,0,0,34.9,38.72v0a26.06,26.06,0,0,0-34.9-38.72Z",
    transform: "translate(-131.41 -117.6)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M778.69,646.27A80.67,80.67,0,0,1,685,656.77l2.58-4.59a75.43,75.43,0,0,0,97.27-20.46l.11-.14.1-.14a75.35,75.35,0,1,0-133.7-27l-5.12,1.25a80.66,80.66,0,0,1,138.1-73.27,81.72,81.72,0,0,1,11.51,16.5,80.55,80.55,0,0,1-17.2,97.39Z",
    transform: "translate(-131.41 -117.6)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M903.66,637.74a1.45,1.45,0,0,1-.52-.69,1.36,1.36,0,0,1,.86-1.73c1.74-.59,3.53-1.13,5.3-1.6a1.36,1.36,0,1,1,.7,2.63c-1.72.46-3.44,1-5.13,1.55A1.39,1.39,0,0,1,903.66,637.74Z",
    transform: "translate(-131.41 -117.6)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M1012.47,742.13a1.36,1.36,0,0,1-.54-1.5,83.8,83.8,0,0,0,2.4-11,1.36,1.36,0,1,1,2.7.4,87.32,87.32,0,0,1-2.48,11.33,1.37,1.37,0,0,1-1.69.93A1.41,1.41,0,0,1,1012.47,742.13Zm3.19-29.65a1.37,1.37,0,0,1-.6-1,83.17,83.17,0,0,0-1.51-11.13,1.37,1.37,0,1,1,2.68-.54,88.16,88.16,0,0,1,1.56,11.49,1.36,1.36,0,0,1-1.27,1.45A1.39,1.39,0,0,1,1015.66,712.48Zm-88.46-79.1a1.39,1.39,0,0,1-.59-1.07,1.36,1.36,0,0,1,1.3-1.42c2.06-.09,4.15-.1,6.22,0,1.79,0,3.6.16,5.38.32a1.37,1.37,0,0,1-.25,2.72c-1.72-.16-3.47-.26-5.21-.31-2-.06-4-.05-6,0A1.32,1.32,0,0,1,927.2,633.38Zm81.23,50.16a1.29,1.29,0,0,1-.47-.56,84,84,0,0,0-5.28-9.91,1.37,1.37,0,1,1,2.32-1.44,87.91,87.91,0,0,1,5.45,10.23,1.37,1.37,0,0,1-2,1.68Zm-51.66-46.21a1.35,1.35,0,0,1-.53-1.54,1.37,1.37,0,0,1,1.71-.88,86.11,86.11,0,0,1,10.79,4.27,1.36,1.36,0,1,1-1.18,2.46,83,83,0,0,0-10.44-4.13A1.16,1.16,0,0,1,956.77,637.33Zm34.87,21.57a1.2,1.2,0,0,1-.21-.17,83.76,83.76,0,0,0-8.37-7.5,1.36,1.36,0,0,1-.23-1.91,1.38,1.38,0,0,1,1.91-.23,86.69,86.69,0,0,1,8.64,7.73,1.36,1.36,0,0,1-1.74,2.08Z",
    transform: "translate(-131.41 -117.6)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M1002.56,764a1.37,1.37,0,0,1-.39-1.86c1-1.51,1.89-3.06,2.74-4.62a1.37,1.37,0,0,1,1.86-.53,1.32,1.32,0,0,1,.53,1.85c-.88,1.61-1.83,3.21-2.83,4.77a1.36,1.36,0,0,1-1.88.41Z",
    transform: "translate(-131.41 -117.6)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M945.75,802a1.37,1.37,0,0,1,.54-2.47c1.75-.31,3.52-.68,5.25-1.1a1.34,1.34,0,0,1,1.64,1,1.36,1.36,0,0,1-1,1.65c-1.78.43-3.61.82-5.42,1.14A1.37,1.37,0,0,1,945.75,802Z",
    transform: "translate(-131.41 -117.6)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M888.77,792.23a1.36,1.36,0,0,1-.41-1.8,1.37,1.37,0,0,1,1.86-.51,84.39,84.39,0,0,0,9.94,4.83,1.36,1.36,0,1,1-1,2.52,85.13,85.13,0,0,1-10.26-5ZM874,781.57l-.14-.12a85.29,85.29,0,0,1-8-8.17,1.36,1.36,0,1,1,2.07-1.77,83.47,83.47,0,0,0,7.71,7.91,1.37,1.37,0,0,1,.11,1.93A1.39,1.39,0,0,1,874,781.57Zm42.4,20.55a1.33,1.33,0,0,1-.57-1.35,1.35,1.35,0,0,1,1.57-1.12,84.05,84.05,0,0,0,11,1.14,1.37,1.37,0,0,1-.1,2.73,87.85,87.85,0,0,1-11.35-1.18A1.29,1.29,0,0,1,916.4,802.12Zm-60.52-43.63a1.36,1.36,0,0,1-.44-.48,87.16,87.16,0,0,1-4.71-10.38,1.36,1.36,0,0,1,2.55-1,82.74,82.74,0,0,0,4.57,10.06,1.37,1.37,0,0,1-2,1.77Zm-9.19-27.86a1.39,1.39,0,0,1-.58-.94,87.86,87.86,0,0,1-.89-11.37,1.37,1.37,0,1,1,2.73,0,82.52,82.52,0,0,0,.86,11,1.37,1.37,0,0,1-1.15,1.55A1.4,1.4,0,0,1,846.69,730.63Zm.83-29.34a1.37,1.37,0,0,1-.57-1.4,86.81,86.81,0,0,1,3-11,1.36,1.36,0,0,1,2.58.89,84.81,84.81,0,0,0-2.92,10.66,1.36,1.36,0,0,1-1.6,1.06A1.33,1.33,0,0,1,847.52,701.29Z",
    transform: "translate(-131.41 -117.6)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M858.3,673.93a1.36,1.36,0,0,1-.39-1.84c1-1.57,2-3.12,3-4.62a1.38,1.38,0,0,1,1.89-.35v0a1.35,1.35,0,0,1,.33,1.9c-1,1.45-2,3-2.95,4.48a1.36,1.36,0,0,1-1.87.45Z",
    transform: "translate(-131.41 -117.6)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M883.36,673.17a1,1,0,0,0-.27,1.15l4.75,11.48a54,54,0,0,0-7.7,15.75l-12,3.32a1,1,0,0,0-.74.92l-.91,14.87a1,1,0,0,0,.62,1l11.47,4.75A53.91,53.91,0,0,0,884.33,743l-6.11,10.82a1,1,0,0,0,.12,1.17l9.87,11.16a1,1,0,0,0,1.16.27l11.47-4.75a53.89,53.89,0,0,0,15.75,7.69l3.32,12a1,1,0,0,0,.92.75l14.87.91a1,1,0,0,0,1-.63l4.76-11.46A54.09,54.09,0,0,0,958,765.17l10.81,6.11a1,1,0,0,0,1.18-.12l11.16-9.87a1,1,0,0,0,.26-1.16l-4.74-11.47a54.52,54.52,0,0,0,7.69-15.75l12-3.32a1,1,0,0,0,.74-.93l.91-14.87a1,1,0,0,0-.62-1L985.92,708a54.09,54.09,0,0,0-5.71-16.57l6.11-10.81a1,1,0,0,0-.12-1.18l-9.87-11.16a1,1,0,0,0-1.15-.26l-11.48,4.74A54.27,54.27,0,0,0,948,665.1l-3.32-12a1,1,0,0,0-.92-.74l-14.87-.91a1,1,0,0,0-1,.62l-4.75,11.47a54.06,54.06,0,0,0-16.58,5.71l-10.81-6.12a1,1,0,0,0-1.18.13Z",
    transform: "translate(-131.41 -117.6)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M923.67,729.85h0a15.27,15.27,0,1,1,11.45,2.4A15.19,15.19,0,0,1,923.65,729.84ZM938.57,708A11.18,11.18,0,0,0,926,726.46h0A11.18,11.18,0,0,0,938.57,708Z",
    transform: "translate(-131.41 -117.6)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M911.15,748.87A38.08,38.08,0,0,1,895.68,708l.24-.89,3.94,1.1a34.19,34.19,0,0,0-1.2,7.12h0a34.07,34.07,0,0,0,.43,7.85v0a34,34,0,0,0,20,25.3,33.64,33.64,0,0,0,8.57,2.43l.29,0,.24,0,.61.07c.54.06,1.1.11,1.66.14A33.65,33.65,0,0,0,955,742.84a34.27,34.27,0,0,0,5.6-6.34,33.91,33.91,0,0,0-43.65-49.16L915,683.71a38,38,0,0,1,48.92,55.09,38.3,38.3,0,0,1-6.27,7.11,38,38,0,0,1-46.52,3Z",
    transform: "translate(-131.41 -117.6)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M1122.38,515a1.32,1.32,0,0,1-.63-1.07c-.09-1.77-.21-3.54-.36-5.26a1.33,1.33,0,1,1,2.65-.24c.16,1.76.29,3.57.37,5.37a1.34,1.34,0,0,1-1.27,1.4A1.31,1.31,0,0,1,1122.38,515Z",
    transform: "translate(-131.41 -117.6)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M928.37,629.86c-2.65-1.63-5.28-3.37-7.79-5.17a1.33,1.33,0,1,1,1.55-2.17c2.9,2.08,5.93,4.06,9,5.89h0a1.33,1.33,0,0,1-1.38,2.28Zm17.18,8.78a1.33,1.33,0,0,1,1.21-2.36c3.3,1.38,6.7,2.63,10.1,3.73a1.32,1.32,0,0,1,.86,1.68,1.34,1.34,0,0,1-1.68.86c-3.47-1.12-6.94-2.41-10.31-3.82Zm27.36,8a1.33,1.33,0,0,1,.93-2.45c3.52.62,7.11,1.1,10.67,1.42a1.34,1.34,0,0,1-.24,2.66c-3.63-.33-7.3-.82-10.9-1.46A1.41,1.41,0,0,1,972.91,646.68Zm28.45,1.79a1.3,1.3,0,0,1-.64-1.07A1.33,1.33,0,0,1,1002,646c3.57-.18,7.17-.51,10.72-1a1.33,1.33,0,1,1,.36,2.64c-3.62.5-7.3.84-10.94,1A1.31,1.31,0,0,1,1001.36,648.47Zm28.12-4.61a1.33,1.33,0,0,1,.33-2.42c3.44-1,6.88-2.1,10.23-3.36a1.33,1.33,0,1,1,.94,2.49c-3.42,1.29-6.94,2.44-10.44,3.44A1.34,1.34,0,0,1,1029.48,643.86Zm26.4-10.75a1.34,1.34,0,0,1,.06-2.31c3.15-1.71,6.25-3.57,9.23-5.54a1.34,1.34,0,0,1,1.47,2.23c-3,2-6.21,3.91-9.43,5.65A1.32,1.32,0,0,1,1055.88,633.11Zm23.38-16.32a1.26,1.26,0,0,1-.31-.26,1.34,1.34,0,0,1,.12-1.88c2.69-2.36,5.31-4.87,7.78-7.45a1.34,1.34,0,0,1,1.93,1.85c-2.53,2.63-5.2,5.19-8,7.6A1.31,1.31,0,0,1,1079.26,616.79Zm19.17-21.1-.08-.06a1.33,1.33,0,0,1-.3-1.86c1.85-2.56,3.62-5.23,5.26-7.91.22-.36.44-.72.65-1.09a1.34,1.34,0,0,1,1.83-.46h0a1.32,1.32,0,0,1,.45,1.82l-.66,1.11c-1.69,2.74-3.49,5.46-5.38,8.08A1.34,1.34,0,0,1,1098.43,595.69Zm14-24.86a1.33,1.33,0,0,1-.53-1.65c1.39-3.29,2.65-6.69,3.76-10.09a1.33,1.33,0,0,1,2.54.82c-1.13,3.48-2.43,7-3.84,10.3a1.33,1.33,0,0,1-1.75.71Zm8.12-27.34a1.31,1.31,0,0,1-.62-1.37c.63-3.53,1.12-7.12,1.45-10.67a1.33,1.33,0,0,1,2.65.25c-.33,3.62-.83,7.29-1.48,10.89a1.33,1.33,0,0,1-1.54,1.08A1.17,1.17,0,0,1,1120.52,543.49Z",
    transform: "translate(-131.41 -117.6)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M907,613.42a1.81,1.81,0,0,1-.23-.18c-1.3-1.25-2.59-2.53-3.81-3.8a1.33,1.33,0,1,1,1.92-1.84c1.2,1.24,2.45,2.49,3.74,3.72a1.33,1.33,0,0,1-1.62,2.1Z",
    transform: "translate(-131.41 -117.6)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M867.44,521.66a1.32,1.32,0,0,1-.64-1.13c0-1.77,0-3.59.09-5.38a1.33,1.33,0,0,1,2.66.1c-.06,1.76-.09,3.53-.09,5.27a1.32,1.32,0,0,1-1.32,1.34A1.27,1.27,0,0,1,867.44,521.66Z",
    transform: "translate(-131.41 -117.6)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M869.38,499a1.32,1.32,0,0,1-.62-1.37c.62-3.52,1.41-7.08,2.32-10.56a1.33,1.33,0,1,1,2.58.68c-.9,3.41-1.66,6.89-2.27,10.35a1.34,1.34,0,0,1-1.55,1.08A1.23,1.23,0,0,1,869.38,499Zm7.85-26.93a1.33,1.33,0,0,1-.53-1.65c1.37-3.32,2.91-6.63,4.56-9.81a1.33,1.33,0,1,1,2.36,1.22c-1.61,3.12-3.11,6.35-4.46,9.61a1.33,1.33,0,0,1-1.74.72Zm13.55-24.58-.08,0a1.33,1.33,0,0,1-.32-1.85c2.07-2.94,4.29-5.82,6.61-8.57a1.33,1.33,0,0,1,2,1.72c-2.27,2.69-4.44,5.51-6.47,8.38A1.32,1.32,0,0,1,890.78,447.53Zm18.61-21a1,1,0,0,1-.29-.24,1.33,1.33,0,0,1,.09-1.88c2.67-2.41,5.47-4.74,8.33-6.91a1.33,1.33,0,0,1,1.61,2.12c-2.8,2.13-5.54,4.41-8.15,6.76A1.33,1.33,0,0,1,909.39,426.54Zm22.75-16.41a1.34,1.34,0,0,1,0-2.3c3.12-1.77,6.36-3.43,9.63-4.93a1.33,1.33,0,0,1,1.11,2.42c-3.19,1.47-6.37,3.1-9.43,4.83A1.33,1.33,0,0,1,932.14,410.13Zm25.77-11.07a1.41,1.41,0,0,1-.58-.75,1.33,1.33,0,0,1,.89-1.66c3.44-1,7-2,10.47-2.72a1.33,1.33,0,0,1,.56,2.61c-3.44.73-6.88,1.63-10.25,2.65A1.33,1.33,0,0,1,957.91,399.06Zm27.56-5.17a1.34,1.34,0,0,1,.6-2.47c3.58-.26,7.22-.38,10.81-.35a1.34,1.34,0,0,1,0,2.67c-3.51,0-7.07.08-10.58.34A1.36,1.36,0,0,1,985.47,393.89Zm28,1a1.34,1.34,0,0,1,.89-2.46c3.54.53,7.12,1.21,10.63,2a1.34,1.34,0,0,1-.61,2.6c-3.44-.81-6.94-1.48-10.41-2A1.43,1.43,0,0,1,1013.5,394.91Zm27.14,7.11a1.34,1.34,0,0,1,1.17-2.39c3.37,1.29,6.71,2.73,9.94,4.29a1.33,1.33,0,0,1-1.16,2.4c-3.16-1.52-6.43-2.94-9.73-4.2Zm33.6,19.14-.13-.1c-2.76-2.18-5.64-4.28-8.57-6.23a1.33,1.33,0,0,1,1.48-2.22c3,2,5.93,4.13,8.75,6.37a1.33,1.33,0,0,1-1.53,2.18Z",
    transform: "translate(-131.41 -117.6)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M1090.74,436.86a1.3,1.3,0,0,1-.31-.26c-1.16-1.33-2.36-2.63-3.56-3.89a1.33,1.33,0,0,1,1.93-1.84c1.22,1.28,2.44,2.62,3.63,4a1.33,1.33,0,0,1-1.69,2Z",
    transform: "translate(-131.41 -117.6)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1076.8,465a1.54,1.54,0,0,0-1.59-.8l-18.4,2.9a81.46,81.46,0,0,0-20.27-16.74l-.65-18.6a1.52,1.52,0,0,0-1.08-1.41l-21.37-6.55a1.52,1.52,0,0,0-1.68.57l-11,15A81.18,81.18,0,0,0,974.63,442L961,429.27a1.53,1.53,0,0,0-1.76-.24l-19.73,10.48a1.54,1.54,0,0,0-.8,1.59l2.9,18.4a81.46,81.46,0,0,0-16.74,20.27l-18.6.65a1.52,1.52,0,0,0-1.41,1.08l-6.55,21.37a1.52,1.52,0,0,0,.57,1.68l15.05,11a81.21,81.21,0,0,0,2.51,26.17l-12.7,13.62a1.53,1.53,0,0,0-.24,1.76L914,576.79a1.54,1.54,0,0,0,1.59.8l18.4-2.9a81.46,81.46,0,0,0,20.27,16.74l.65,18.6a1.52,1.52,0,0,0,1.08,1.41L977.35,618a1.52,1.52,0,0,0,1.68-.57l11-15a80.9,80.9,0,0,0,26.17-2.51l13.62,12.7a1.53,1.53,0,0,0,1.76.24l19.73-10.48a1.54,1.54,0,0,0,.8-1.59l-2.9-18.4a81.46,81.46,0,0,0,16.74-20.27l18.6-.65a1.52,1.52,0,0,0,1.41-1.08l6.55-21.37a1.52,1.52,0,0,0-.57-1.68l-15.05-11a81.18,81.18,0,0,0-2.51-26.17l12.7-13.62a1.53,1.53,0,0,0,.24-1.76Z",
    transform: "translate(-131.41 -117.6)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M984,539.57a21.86,21.86,0,1,1,10.28,3.16A21.84,21.84,0,0,1,984,539.57Zm20.67-33.89a17.69,17.69,0,0,0-8.41-2.58h0a17.83,17.83,0,1,0,12.34,5.84A18,18,0,0,0,1004.69,505.68Zm-8.31-4.58h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M965.82,568.88a55.92,55.92,0,0,1,45.55-101.17l1.34.43a56.6,56.6,0,0,1,8.65,3.71l1,.53-2,3.49a52.32,52.32,0,0,0-10.17-4.34l-.1,0a51.92,51.92,0,1,0,29.19,76.75,52,52,0,0,0,6.12-39.52l3.88-1a55.94,55.94,0,0,1-83.47,61.11Z",
    transform: "translate(-131.41 -117.6)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1801.22,1344.24l-8.75-626.69c-.1-6.88,5.81-12.5,13.13-12.5h0c11.84,0,21.44-9,21.44-20.14V531.84c0-9.75,8.6-17.56,19-17.23l47.23,1.47c11.62.36,20.91,9.21,21.13,20.13l16.15,808Z",
    transform: "translate(-131.41 -117.6)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2007.56,1460.14a4,4,0,0,0,4-4V983.46a4,4,0,0,0-7.91,0v472.73A4,4,0,0,0,2007.56,1460.14Z",
    transform: "translate(-131.41 -117.6)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2114.73,1460.14a4,4,0,0,0,4-4V983.46a4,4,0,0,0-7.91,0v472.73A4,4,0,0,0,2114.73,1460.14Z",
    transform: "translate(-131.41 -117.6)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2378.05,1463.14a3.83,3.83,0,0,0,1.54-.32,4,4,0,0,0,2.09-5.19L2179.44,981.92a3.95,3.95,0,0,0-7.27,3.09l202.23,475.72A4,4,0,0,0,2378.05,1463.14Z",
    transform: "translate(-131.41 -117.6)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2253.12,1463.14a3.84,3.84,0,0,0,1.55-.32,4,4,0,0,0,2.09-5.19L2054.52,981.92a4,4,0,0,0-7.28,3.09l202.24,475.72A4,4,0,0,0,2253.12,1463.14Z",
    transform: "translate(-131.41 -117.6)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1864.44,
    y: 859.07,
    width: 196.4,
    height: 11.15,
    rx: 2.81
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2081.44,1060.16h125.29a4,4,0,0,0,0-7.91H2081.44a4,4,0,1,0,0,7.91Z",
    transform: "translate(-131.41 -117.6)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1988.47,
    y: 1024.62,
    width: 125.29,
    height: 7.91
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2025.69,
    y: 1114.59,
    width: 125.29,
    height: 7.91
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2196.13,1330.07h125.29a4,4,0,0,0,0-7.91H2196.13a4,4,0,1,0,0,7.91Z",
    transform: "translate(-131.41 -117.6)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2233.86,1420h125.29a4,4,0,1,0,0-7.91H2233.86a4,4,0,0,0,0,7.91Z",
    transform: "translate(-131.41 -117.6)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M218,805.47l-10.77,2.72c-18.5,4.68-30.94,18.57-27.78,31l3.74,14.83c3.16,12.47,20.7,18.79,39.2,14.11l10.78-2.72c.71-.18,1.42-.38,2.13-.59l316-94.56L543.14,738l-323,67C219.41,805.12,218.69,805.29,218,805.47Zm4.65,14.79c13.92-3.52,26.9.34,29,8.61s-7.5,17.84-21.42,21.36-26.91-.34-29-8.61S208.69,823.78,222.62,820.26Z",
    transform: "translate(-131.41 -117.6)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M648.22,694.12l-62.54,15.8a14.85,14.85,0,0,0-10,8.47L566.37,740a14.78,14.78,0,0,0,4.42,17.51l18.5,14.56a14.8,14.8,0,0,0,12.79,2.72L664.61,759c9.44-2.39,17.45,7.46,13,16.11a85.18,85.18,0,0,1-55.09,43.35c-45,11.37-84.77-15.88-95.71-59.14S538,673.16,582.92,661.8a85.12,85.12,0,0,1,69.07,12C660,679.26,657.65,691.73,648.22,694.12Z",
    transform: "translate(-131.41 -117.6)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M649.71,700l-62.54,15.81a14.8,14.8,0,0,0-10,8.47l-9.35,21.6a14.8,14.8,0,0,0,4.42,17.52L590.78,778a14.83,14.83,0,0,0,12.79,2.72l62.53-15.81c9.44-2.38,17.45,7.46,13,16.11A85.15,85.15,0,0,1,624,824.34c-45,11.37-84.77-15.88-95.71-59.13s11.14-86.15,56.11-97.52a85.12,85.12,0,0,1,69.07,12C661.51,685.16,659.14,697.63,649.71,700Z",
    transform: "translate(-131.41 -117.6)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.16,810.17l-10.77,2.72c-18.5,4.68-30.94,18.58-27.78,31.05l3.74,14.82c3.15,12.47,20.7,18.79,39.2,14.12l10.77-2.73c.72-.18,1.43-.37,2.13-.59l316-94.56-8.16-32.3-323,67C220.59,809.82,219.88,810,219.16,810.17ZM223.8,825c13.93-3.51,26.91.34,29,8.61s-7.5,17.84-21.42,21.36-26.91-.34-29-8.61S209.88,828.48,223.8,825Z",
    transform: "translate(-131.41 -117.6)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1935.55,394.75a1.24,1.24,0,0,0,.47-1.68l-1.7-3-.13.07-10-16.19a1.23,1.23,0,0,0-1.7-.4l-1.89,1.16a1.23,1.23,0,0,0-.4,1.7l9.22,15a1.23,1.23,0,0,1-.45,1.71l-72.44,40.85a1.23,1.23,0,0,0-.46,1.68l1.69,3h0l23.54,41.74a1.23,1.23,0,0,0,1.67.47l1.94-1.09a1.24,1.24,0,0,0,.47-1.68l-22.94-40.67a1.24,1.24,0,0,1,.47-1.68Z",
    transform: "translate(-131.41 -117.6)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 1820.93,
    y: 311.93,
    width: 39.2,
    height: 172.36,
    transform: "translate(2266.41 2079.26) rotate(-119.42)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M2036.14,770.29l-9.49,4.8a1.49,1.49,0,0,1-2-.66l-149.84-296a1.49,1.49,0,0,1,.66-2l9.48-4.81a1.52,1.52,0,0,1,2,.66l149.84,296A1.49,1.49,0,0,1,2036.14,770.29Z",
    transform: "translate(-131.41 -117.6)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-261",
    cx: 1765.39,
    cy: 440.32,
    rx: 7.33,
    ry: 19.75,
    transform: "translate(-120.04 806.35) rotate(-29.42)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M1920.92,352.78c5.36,9.5,6.84,18.81,3.32,20.8s-10.72-4.11-16.08-13.6-6.84-18.82-3.32-20.8S1915.56,343.28,1920.92,352.78Z",
    transform: "translate(-131.41 -117.6)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2074.57,1481.6c-36.23,12.1-71.42,12.11-105.36,1.05a20.86,20.86,0,0,1-14.4-19.82V1296.6c41.71,9.18,85.43,9.64,131.49,0v168.81A17.11,17.11,0,0,1,2074.57,1481.6Z",
    transform: "translate(-131.41 -117.6)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1889.15,
    cy: 1177.67,
    rx: 65.74,
    ry: 13.21
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2086.3,1424.6q-65.75,22.86-131.49,0v-66.32c44.23,10.91,88.07,11.46,131.49,0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1961.87,1311.71a11,11,0,0,0,12.7,7.51c3.71-.92,6.88-3.82,10.7-3.88,4.34-.08,7.8,3.5,10.33,7a69.76,69.76,0,0,1,10.28,21.17c.74,2.52,1.38,5.19,3.15,7.13,3.79,4.15,11,2.82,15.17-.9s6.5-9.08,9.63-13.75,7.93-9,13.54-8.68c1.88.12,3.69.76,5.57.84a9.67,9.67,0,0,0,9.4-6.78,16.42,16.42,0,0,1,1.1-3.65c1.9-3.33,6.92-3.65,9.52-6.34,1.65-1.71,2.2-4.2,4.12-5.88.73-.63,5.71-2.69,5.82-3,.87-2.68-1.91-5.1-4.49-6.25-15.11-6.73-32.39,0-48.78,2.28-16.09,2.25-31.5-1.42-47.44-1.28C1973.39,1297.34,1958.59,1299.45,1961.87,1311.71Z",
    transform: "translate(-131.41 -117.6)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-263",
    cx: 1889.91,
    cy: 1178.05,
    rx: 65.74,
    ry: 13.21
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-264",
    cx: 1888.16,
    cy: 1178.05,
    rx: 54.12,
    ry: 7.99
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1557.9,758.85H1293c-8.45,0-15.29-5.06-15.29-11.3V558.62c0-6.23,6.82-11.28,15.25-11.3l267-.53c8.5,0,15.38,5.09,15.34,11.36l-2.12,189.46C1573.15,753.83,1566.32,758.85,1557.9,758.85Z",
    transform: "translate(-131.41 -117.6)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1544.93,561.25l-236.84,1.08c-8.56,0-15.46,5.19-15.42,11.52l1.65,158.9c0,6.23,6.81,11.3,15.24,11.41l230.11,3.1c8.59.12,15.68-5,15.8-11.3l5.07-163.08C1560.66,566.46,1553.62,561.21,1544.93,561.25Z",
    transform: "translate(-131.41 -117.6)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1535.3,576v1.21c0,1.89-2.08,3.43-4.65,3.43H1348.18c-2.57,0-4.65-1.54-4.65-3.43V576c0-1.89,2.08-3.43,4.65-3.43h182.47C1533.22,572.56,1535.3,574.1,1535.3,576Z",
    transform: "translate(-131.41 -117.6)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1514.94,591.16h0c-.14,1.8-2.12,3.21-4.55,3.25l-159.59,2.15c-2.6,0-4.73-1.52-4.73-3.43v-.28c0-1.88,2-3.4,4.57-3.43l159.59-1.87C1512.92,587.52,1515.08,589.18,1514.94,591.16Z",
    transform: "translate(-131.41 -117.6)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1531.23,738.85h-.16l-215.85-1.91a14.65,14.65,0,0,1-10.41-4.09,9,9,0,0,1-2.66-6.47l5.56-112.23c.14-5.58,6-10.09,13.22-10.09h.25l215.47,3.1a14.6,14.6,0,0,1,10.33,4.11,9,9,0,0,1,2.65,6.43v0l-5.18,111C1544.31,734.42,1538.52,738.85,1531.23,738.85Zm-210.3-130.39c-4.72,0-8.74,2.65-8.82,5.85l-5.56,112.24a4.62,4.62,0,0,0,1.43,3.24,10.34,10.34,0,0,0,7.28,2.74l215.85,1.92h.11c4.72,0,8.75-2.66,8.83-5.85l5.18-111a4.69,4.69,0,0,0-1.42-3.26,10.36,10.36,0,0,0-7.23-2.76l-215.47-3.09Zm226.5,9.19h0Z",
    transform: "translate(-131.41 -117.6)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1544.63,630.11H1309.56a2.2,2.2,0,0,1,0-4.4h235.07a2.2,2.2,0,0,1,0,4.4Z",
    transform: "translate(-131.41 -117.6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVg);
export default __webpack_public_path__ + "static/media/profileVG.4df2a0c829bbda65e96cea88ffb32bb7.svg";
export { ForwardRef as ReactComponent };